/* Kyperus — A.R.C story on the product page (sections/kp-pdp-arc.liquid).
   One pinned stage: the A.R.C intro, the shaft and butt drawn at true scale, one proof per bullet,
   then the studio film. Started from the approved artifact; since 2026-10-22 (foam in the homepage's
   material, the story control) this file is the source. */
(() => {
  function init(root){
    const NS = 'http://www.w3.org/2000/svg';
    const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const clamp = (v,a=0,b=1) => Math.min(b, Math.max(a, v));
    const lerp = (a,b,t) => a + (b-a)*t;
    const sm = t => { t = clamp(t); return t*t*(3-2*t); };
    const win = (t,a,b) => sm((t-a)/(b-a));
    const f1 = n => n.toFixed(1);
  
    /* ---------- world geometry (units, Ø = 120). Proportions read from the team's section clips; illustrative. ---------- */
    const R = 60, T = 8, BORE = R - T;
    const Y = { tip:0, fer:52, ins:100, hol:150, foam:510, end:1000 };
    const BALL = R * 57.15/12.5;                       // cue ball radius at the same scale as the shaft
    const CONTACT = [18, 4];
    const BA = .32, BALLC = [CONTACT[0] + BALL*Math.sin(BA), CONTACT[1] - BALL*Math.cos(BA)];
    // angled hero: face at local x=0, body along +x
    const HR = 110, HCORE = .62, PL = 5, ANG = [0, 45, -45, 90, 0], HL = 560, HO = [-120, 380], HROT = -24, FX = .52;
    const HTH = HR*(1 - HCORE)/PL, HRF = HR*HCORE, PEEL = 18;
    const HX = [[230, 0], [230, Math.PI], [-230, Math.PI/2], [-230, -Math.PI/2]];
  
    // the foam is ultra high-density: a fine, even grain, not bubbles (the same material as the homepage scene).
    // One 128-px tile of grain, drawn once; the pattern is rescaled each frame so a grain stays one screen pixel
    const GRAIN = (() => { const g = document.createElement('canvas'); g.width = g.height = 128; const c = g.getContext('2d'), r = (() => { let s = 7; return () => (s = (s*16807) % 2147483647)/2147483647; })();
      for (let i = 0; i < 2600; i++){ const v = r() < .5 ? 0 : 255; c.fillStyle = `rgba(${v},${v},${v},${.05 + r()*.14})`; c.fillRect(Math.floor(r()*128), Math.floor(r()*128), 1, 1); }
      return g.toDataURL(); })();
    const plyFill = i => ['#1a1a1a','#2e2e2e','#1f1f1f','#383838','#262626'][i];
  
    const defs = `<defs>
      <pattern id="kpa-grid" width="40" height="40" patternUnits="userSpaceOnUse"><path id="kpa-gridP" d="M40 0H0V40" fill="none" stroke="rgba(237,237,237,.06)"/></pattern>
      ${ANG.map((a,i) => `<pattern id="kpa-ply${i}" width="3.2" height="3.2" patternUnits="userSpaceOnUse" patternTransform="rotate(${a})"><line x1="0" y1="1.6" x2="3.2" y2="1.6" stroke="rgba(255,255,255,.2)" stroke-width=".7"/></pattern><pattern id="kpa-bply${i}" width="7" height="7" patternUnits="userSpaceOnUse" patternTransform="rotate(${a})"><line x1="0" y1="3.5" x2="7" y2="3.5" stroke="rgba(255,255,255,.14)" stroke-width="1"/></pattern>`).join('')}
      <pattern id="kpa-cells" width="128" height="128" patternUnits="userSpaceOnUse"><image href="${GRAIN}" width="128" height="128"/></pattern>
      <linearGradient id="kpa-bodyH" x1="0" y1="${-HR}" x2="0" y2="${HR}" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#0a0a0a"/><stop offset=".14" stop-color="#2f2f2f"/><stop offset=".26" stop-color="#4a4a4a"/><stop offset=".42" stop-color="#262626"/><stop offset=".78" stop-color="#0f0f0f"/><stop offset="1" stop-color="#040404"/></linearGradient>
      <linearGradient id="kpa-band" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#151515"/><stop offset=".18" stop-color="#4a4a4a"/><stop offset=".38" stop-color="#2a2a2a"/><stop offset=".8" stop-color="#0c0c0c"/><stop offset="1" stop-color="#050505"/></linearGradient>
      <radialGradient id="kpa-foamTop" cx=".42" cy=".35" r=".75"><stop offset="0" stop-color="#727270"/><stop offset="1" stop-color="#3a3a39"/></radialGradient>
      <linearGradient id="kpa-foamV" x1="0" x2="1"><stop offset="0" stop-color="#2c2c2c"/><stop offset=".28" stop-color="#6a6a68"/><stop offset=".5" stop-color="#5a5a58"/><stop offset="1" stop-color="#262626"/></linearGradient>
      <linearGradient id="kpa-wallV" x1="0" x2="1"><stop offset="0" stop-color="#262626"/><stop offset="1" stop-color="#0d0d0d"/></linearGradient>
      <linearGradient id="kpa-ferV" x1="0" x2="1"><stop offset="0" stop-color="#8a867f"/><stop offset=".3" stop-color="#ece8df"/><stop offset=".6" stop-color="#d6d1c7"/><stop offset="1" stop-color="#77736c"/></linearGradient>
      <linearGradient id="kpa-tipV" x1="0" x2="1"><stop offset="0" stop-color="#0b0a09"/><stop offset=".3" stop-color="#3a322c"/><stop offset=".55" stop-color="#211c18"/><stop offset="1" stop-color="#070606"/></linearGradient>
      <linearGradient id="kpa-fadeR" x1="0" x2="1"><stop offset="0" stop-color="#fff"/><stop offset=".55" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>
      <linearGradient id="kpa-fadeD" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#fff"/><stop offset=".62" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>
      <linearGradient id="kpa-fadeM" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>
      <linearGradient id="kpa-steelV" x1="0" x2="1"><stop offset="0" stop-color="#4f5357"/><stop offset=".3" stop-color="#e4e6e8"/><stop offset=".55" stop-color="#b3b7bb"/><stop offset="1" stop-color="#46494d"/></linearGradient>
      <linearGradient id="kpa-steelSheen" x1="0" x2="1"><stop offset="0" stop-color="#000" stop-opacity=".6"/><stop offset=".3" stop-color="#fff" stop-opacity=".12"/><stop offset=".55" stop-color="#fff" stop-opacity=".03"/><stop offset="1" stop-color="#000" stop-opacity=".7"/></linearGradient>
      <linearGradient id="kpa-mapleV" x1="0" x2="1"><stop offset="0" stop-color="#5f5340"/><stop offset=".3" stop-color="#b8a67c"/><stop offset=".6" stop-color="#a6966e"/><stop offset="1" stop-color="#5a4e3b"/></linearGradient>
      <pattern id="kpa-grain" width="34" height="240" patternUnits="userSpaceOnUse"><path d="M6 0Q10 120 6 240M17 0Q13 90 18 240M27 0Q30 140 26 240" fill="none" stroke="rgba(50,38,18,.28)" stroke-width=".8"/></pattern>
      <linearGradient id="kpa-glossV" x1="0" x2="1"><stop offset="0" stop-color="#0c0c0c"/><stop offset=".26" stop-color="#6a6a6a"/><stop offset=".34" stop-color="#2a2a2a"/><stop offset="1" stop-color="#050505"/></linearGradient>
      <pattern id="kpa-pebble" width="9" height="9" patternUnits="userSpaceOnUse"><circle cx="2.5" cy="2.5" r="1.7" fill="rgba(255,255,255,.2)"/><circle cx="7" cy="6.8" r="1.4" fill="rgba(255,255,255,.14)"/></pattern>
      <linearGradient id="kpa-massG" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ededed" stop-opacity=".08"/><stop offset=".48" stop-color="#ededed" stop-opacity=".14"/>
        <stop offset=".5" stop-color="#ededed" stop-opacity=".6"/><stop offset=".525" stop-color="#ededed" stop-opacity=".26"/>
        <stop offset=".675" stop-color="#ededed" stop-opacity=".42"/><stop offset=".682" stop-color="#ff6b00"/><stop offset=".728" stop-color="#ff6b00"/>
        <stop offset=".735" stop-color="#ededed" stop-opacity=".46"/><stop offset="1" stop-color="#ededed" stop-opacity=".56"/></linearGradient>
      <clipPath id="kpa-massClip"><rect id="kpa-massClipR" x="-3000" y="0" width="6000" height="0"/></clipPath>
      <pattern id="kpa-grainL" width="40" height="40" patternUnits="userSpaceOnUse"><g fill="rgba(255,255,255,.13)" stroke="rgba(0,0,0,.55)" stroke-width=".8">
        <circle cx="6" cy="7" r="5.5"/><circle cx="20" cy="5" r="4.5"/><circle cx="33" cy="9" r="6"/><circle cx="12" cy="20" r="5"/><circle cx="27" cy="22" r="6.5"/>
        <circle cx="4" cy="32" r="4.8"/><circle cx="17" cy="34" r="5.6"/><circle cx="31" cy="35" r="4.6"/><circle cx="39" cy="22" r="3.6"/></g></pattern>
      <clipPath id="kpa-lensClip"><circle id="kpa-lensC" r="0"/></clipPath>
      <clipPath id="kpa-xray"><rect id="kpa-xrayR" x="-400" y="0" width="800" height="0"/></clipPath>
      <clipPath id="kpa-wrapClip"><rect id="kpa-wrapClipR" x="-400" y="0" width="800" height="0"/></clipPath>
      <radialGradient id="kpa-faceLight" cx=".3" cy=".25" r=".9"><stop offset="0" stop-color="#fff" stop-opacity=".16"/><stop offset=".6" stop-color="#fff" stop-opacity="0"/></radialGradient>
      <radialGradient id="kpa-ballG" cx=".35" cy=".3" r=".9"><stop offset="0" stop-color="#2a2927"/><stop offset=".7" stop-color="#121211"/><stop offset="1" stop-color="#0a0a0a"/></radialGradient>
      <clipPath id="kpa-secClip"><rect id="kpa-secClipR" x="-500" y="-60" width="1000" height="0"/></clipPath>
      <clipPath id="kpa-tipClip"><path d="M${-R},${Y.fer} V18 Q0,-10 ${R},18 V${Y.fer} Z"/></clipPath>
      <mask id="kpa-mBody" maskUnits="userSpaceOnUse" x="-10" y="${-HR-10}" width="${HL+20}" height="${2*HR+20}"><rect x="0" y="${-HR-4}" width="${HL}" height="${2*HR+8}" fill="url(#kpa-fadeR)"/></mask>
      <mask id="kpa-mSec" maskUnits="userSpaceOnUse" x="-500" y="-400" width="1000" height="1600"><rect x="-500" y="-400" width="1000" height="${Y.end+400}" fill="#fff"/><rect x="-500" y="640" width="1000" height="${Y.end-640}" fill="#000"/><rect x="-500" y="640" width="1000" height="${Y.end-640}" fill="url(#kpa-fadeM)"/></mask>
    </defs>`;
  
    /* hero: angled section, plies telescope out of the face */
    const ell = (cx, r) => `M${f1(cx)},${f1(-r)} A${f1(FX*r)},${f1(r)} 0 1 0 ${f1(cx)},${f1(r)} A${f1(FX*r)},${f1(r)} 0 1 0 ${f1(cx)},${f1(-r)} Z`;
    const ann = (cx, ro, ri) => ell(cx, ro) + ' ' + `M${f1(cx)},${f1(-ri)} A${f1(FX*ri)},${f1(ri)} 0 1 1 ${f1(cx)},${f1(ri)} A${f1(FX*ri)},${f1(ri)} 0 1 1 ${f1(cx)},${f1(-ri)} Z`;
    let plies = '';
    for (let i=0;i<PL;i++){
      plies += `<g data-p="${i}">${i ? `<path class="pb" fill="url(#kpa-band)"/><path class="pb" fill="url(#kpa-bply${i})"/>` : ''}
        <path class="pf" fill="${plyFill(i)}" fill-rule="evenodd"/><path class="pf" fill="url(#kpa-ply${i})" fill-rule="evenodd"/><path class="pf" fill="none" stroke="rgba(0,0,0,.8)"/><path class="pf" fill="none" stroke="rgba(237,237,237,.32)"/></g>`;
    }
    const heroG = `<g id="kpa-hero" transform="translate(${HO[0]} ${HO[1]}) rotate(${HROT})">
      <g mask="url(#kpa-mBody)">
        <rect x="0" y="${-HR}" width="${HL}" height="${2*HR}" fill="url(#kpa-bodyH)"/>
        <line x1="0" y1="${-HR}" x2="${HL}" y2="${-HR}" stroke="rgba(255,255,255,.22)"/>
        <line x1="0" y1="${HR}" x2="${HL}" y2="${HR}" stroke="rgba(255,255,255,.08)"/>
        <path id="kpa-helix" fill="none" stroke-width="1.5" stroke-linecap="round"/>
      </g>
      <path d="${ell(0, HR)}" fill="#070707"/>
      ${plies}
      <g id="kpa-hFoam"><path fill="url(#kpa-foamTop)"/><path fill="url(#kpa-cells)"/><path fill="none" stroke="#050505" stroke-width="1.4"/></g>
      <path id="kpa-hLight" d="${ell(0, HR)}" fill="url(#kpa-faceLight)" pointer-events="none"/>
      <path id="kpa-hRim" d="${ell(0, HR)}" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="1.1"/>
    </g>`;
  
    /* longitudinal section, tip up */
    const tipLines = Array.from({length:8}, (_,i) => { const y = 20 + i*4.1; return `<line x1="${-R}" y1="${f1(y)}" x2="${R}" y2="${f1(y)}" stroke="rgba(237,237,237,.22)"/>`; }).join('');
    const secG = `<g id="kpa-sec" clip-path="url(#kpa-secClip)"><g>
      <rect x="${-BORE}" y="${Y.foam}" width="${2*BORE}" height="${Y.end-Y.foam}" fill="url(#kpa-foamV)"/>
      <rect x="${-BORE}" y="${Y.foam}" width="${2*BORE}" height="${Y.end-Y.foam}" fill="url(#kpa-cells)"/>
      <line x1="${-BORE}" y1="${Y.foam}" x2="${BORE}" y2="${Y.foam}" stroke="rgba(0,0,0,.6)" stroke-width="1.5"/>
      ${[-1,1].map(s => `<rect x="${s<0 ? -R : BORE}" y="${Y.ins}" width="${T}" height="${Y.end-Y.ins}" fill="url(#kpa-wallV)"/><rect x="${s<0 ? -R : BORE}" y="${Y.ins}" width="${T}" height="${Y.end-Y.ins}" fill="url(#kpa-ply1)"/>`).join('')}
      ${[-R,-BORE,BORE,R].map(x => `<line x1="${x}" y1="${Y.ins}" x2="${x}" y2="${Y.end}" stroke="rgba(237,237,237,.82)" stroke-width="1.2"/>`).join('')}
      <path d="M${-BORE},${Y.ins} H${BORE} V${Y.hol} H22 V${Y.ins+18} H-22 V${Y.hol} H${-BORE} Z" fill="#6f6b65" stroke="rgba(237,237,237,.7)"/>
      <rect x="${-R}" y="${Y.fer}" width="${2*R}" height="${Y.ins-Y.fer}" fill="url(#kpa-ferV)" stroke="rgba(237,237,237,.7)"/>
      <g id="kpa-tipG"><path d="M${-R},${Y.fer} V18 Q0,-10 ${R},18 V${Y.fer} Z" fill="url(#kpa-tipV)"/><g clip-path="url(#kpa-tipClip)">${tipLines}</g>
        <path d="M${-R},${Y.fer} V18 Q0,-10 ${R},18 V${Y.fer} Z" fill="none" stroke="rgba(237,237,237,.8)" stroke-width="1.2"/></g>
    </g></g>`;
  
  
    /* Lower shaft, joint and butt at true diameters from the team's spec drawing (butt 737 mm; collar Ø21.4, Ø25.6 at the
       upper wrap ring 305 mm from the joint, Ø29.8 at the lower ring 610 mm, cap Ø31.5). Length is shortened with break marks;
       inside parts (pin bore, weight bolt slot, insert) follow the team's joint and weight clips and are illustrative. */
    const MM = 2*R/12.5, JY = 737*MM;                                  // true scale: shaft 737 mm, joint face at JY
    const BD = x => 21.4 + (31.5 - 21.4)*x/737;                       // butt Ø (mm) at x mm from the joint
    const rAt = x => BD(x)/2*MM;
    const BSEG = [[0, 737]], BGAP = 0;
    { let y = JY; BSEG.forEach(sg => { sg.y0 = y; y += (sg[1] - sg[0])*MM + BGAP; }); }
    const yAt = x => { const sg = BSEG.find(g => x >= g[0] && x <= g[1]) || BSEG.reduce((a, g) => x > g[1] ? g : a, BSEG[0]); return sg.y0 + (clamp(x, sg[0], sg[1]) - sg[0])*MM; };
    const ZONES = [[0, 18, 'collar'], [18, 28, 'ring'], [28, 300, 'fore'], [300, 314, 'ring'], [314, 606, 'wrap'], [606, 620, 'ring'], [620, 693, 'sleeve'], [693, 705, 'ring'], [705, 737, 'cap']];
    const BUTT = { bal:302, w0:268, w1:336, pin:9.45, pinIn:38, pinOut:22 };   // weight: ~2/3 under the forearm, ~1/3 under the grip
    const RJ = rAt(0), RS0 = R*20.4/12.5;                            // shaft Ø at the joint ≈ collar
    const YB = { cup:JY - 33*MM, foamEnd:JY - 33*MM, taper:250*MM };   // hybrid taper: Ø12.5 to ~250 mm, then out to the joint
    const rs = y => y <= YB.taper ? R : lerp(R, RS0, clamp((y - YB.taper)/(JY - YB.taper)));
    const quad = (xa0, xa1, ya, xb0, xb1, yb) => `M${f1(xa0)},${f1(ya)} L${f1(xa1)},${f1(ya)} L${f1(xb1)},${f1(yb)} L${f1(xb0)},${f1(yb)} Z`;
    const zz = (y, w) => { let d = `M${f1(-w)},${f1(y)}`; for (let x = -w + 9, k = 0; x <= w; x += 9, k++) d += ` L${f1(x)},${f1(y + (k % 2 ? -5 : 5))}`; return d; };
    const side = (f, y0, y1, th) => [-1, 1].map(sg => sg < 0 ? quad(-f(y0), -f(y0) + th, y0, -f(y1), -f(y1) + th, y1) : quad(f(y0) - th, f(y0), y0, f(y1) - th, f(y1), y1)).join(' ');
    const edge = (f, y0, y1, inset, st) => [-1, 1].map(sg => `<line x1="${f1(sg*(f(y0) - inset))}" y1="${f1(y0)}" x2="${f1(sg*(f(y1) - inset))}" y2="${f1(y1)}" stroke="${st}" stroke-width="1.1"/>`).join('');
    // one butt piece between x0 and x1 mm, cut at the segment edges
    function buttPiece(x0, x1, kind){
      let out = '';
      for (const sg of BSEG){
        const a = Math.max(x0, sg[0]), b = Math.min(x1, sg[1]); if (b <= a) continue;
        const ya = yAt(a), yb = yAt(b), f = y => rAt(a + (y - ya)/MM);
        const full = quad(-f(ya), f(ya), ya, -f(yb), f(yb), yb);
        if (kind === 'collar') out += `<path d="${full}" fill="url(#kpa-steelV)" stroke="rgba(237,237,237,.7)"/><path d="${full}" fill="url(#kpa-steelSheen)" opacity=".6"/>
          <line x1="${f1(-f(ya) + 3)}" y1="${f1(ya + 3)}" x2="${f1(f(ya) - 3)}" y2="${f1(ya + 3)}" stroke="rgba(255,255,255,.75)" stroke-width="1.2"/>
          <line x1="${f1(-f(yb))}" y1="${f1(yb - 2)}" x2="${f1(f(yb))}" y2="${f1(yb - 2)}" stroke="rgba(0,0,0,.45)"/>`;
        else if (kind === 'ring') out += `<path d="${full}" fill="#161616" stroke="rgba(237,237,237,.5)"/>` + [.28, .72].map(v => { const y = ya + (yb - ya)*v; return `<path d="${quad(-f(y), f(y), y - .6*MM, -f(y), f(y), y + .6*MM)}" fill="#d9d3c6"/>`; }).join('');
        else if (kind === 'cap') out += `<path d="${full}" fill="#0e0e0e" stroke="rgba(237,237,237,.6)"/>`;
        else if (kind === 'wrap' || kind === 'sleeve'){                // shown from outside: leather, and the dark sleeve
          out += `<path d="${full}" fill="${kind === 'wrap' ? '#171513' : '#121212'}"/>`;
          if (kind === 'wrap') out += `<g clip-path="url(#kpa-wrapClip)"><path d="${full}" fill="url(#kpa-pebble)"/></g>`;
          out += `<path d="${full}" fill="url(#kpa-steelSheen)" opacity=".5"/>` + edge(f, ya, yb, 0, 'rgba(237,237,237,.75)');
        }
        else {
          const th = (kind === 'wrap' ? 2.2 : 1.4)*MM;
          out += `<path d="${quad(-f(ya) + th, f(ya) - th, ya, -f(yb) + th, f(yb) - th, yb)}" fill="url(#kpa-mapleV)"/><path d="${quad(-f(ya) + th, f(ya) - th, ya, -f(yb) + th, f(yb) - th, yb)}" fill="url(#kpa-grain)"/>`;
          out += `<path d="${side(f, ya, yb, th)}" fill="${kind === 'wrap' ? '#1b1816' : '#141414'}"/>`;
          if (kind === 'wrap') out += `<g clip-path="url(#kpa-wrapClip)"><path d="${side(f, ya, yb, th)}" fill="url(#kpa-pebble)"/></g>`;
          out += edge(f, ya, yb, 0, 'rgba(237,237,237,.75)') + edge(f, ya, yb, th, 'rgba(237,237,237,.16)');
        }
      }
      return out;
    }
    const pinY0 = JY - BUTT.pinOut*MM, pinY1 = JY + BUTT.pinIn*MM, pinR = BUTT.pin/2*MM;
    const pinThreads = (y0, y1) => { let d = ''; for (let y = y0; y < y1; y += 1.27*MM) d += `M${f1(-pinR)},${f1(y)}L${f1(-pinR - 5)},${f1(y + .64*MM)}L${f1(-pinR)},${f1(y + 1.27*MM)}M${f1(pinR)},${f1(y)}L${f1(pinR + 5)},${f1(y + .64*MM)}L${f1(pinR)},${f1(y + 1.27*MM)}`; return d; };
    /* 3/8-8 joint pin: the "3/8-8 radial" ball thread (rounded crests and roots, 8 TPI = 3.175 mm pitch), single start.
       Major Ø ≈ .372 in (9.45 mm), minor Ø ≈ .312 in (7.92 mm); about 5 turns exposed, then a short smooth nose. */
    const PITCH = 25.4/8*MM, THR = 5*25.4/8*MM, PIL = 6*MM, rootR = 7.92/2*MM, pilR = 7.6/2*MM;
    // one side of the helix sits half a pitch below the other; the profile is a rounded ball-thread wave
    const thrX = (y, sg) => { const u = (((JY - y)/PITCH + (sg > 0 ? .5 : 0)) % 1 + 1) % 1; return rootR + (pinR - rootR)*Math.pow(Math.sin(Math.PI*u), .55); };
    function pinOutline(){
      const L = [], Rt = [];
      for (let y = JY; y >= JY - THR; y -= 1.5){ L.push([-thrX(y, -1), y]); Rt.push([thrX(y, 1), y]); }
      const yP = JY - THR, yN = yP - PIL, ch = 1.2*MM;
      let d = `M${f1(-pinR)},${f1(JY)}` + L.map(([x, y]) => `L${f1(x)},${f1(y)}`).join('');
      d += `L${f1(-pilR)},${f1(yP)}L${f1(-pilR)},${f1(yN + ch)}Q${f1(-pilR)},${f1(yN)} ${f1(-pilR + ch)},${f1(yN)}L${f1(pilR - ch)},${f1(yN)}Q${f1(pilR)},${f1(yN)} ${f1(pilR)},${f1(yN + ch)}L${f1(pilR)},${f1(yP)}`;
      d += Rt.reverse().map(([x, y]) => `L${f1(x)},${f1(y)}`).join('') + `L${f1(pinR)},${f1(JY)}Z`;
      return d;
    }
    // crest highlights and root shadows run across the face on the helix: left at one height, right half a pitch lower
    function pinCrests(){ let d = ''; for (let k = 0; k < 5; k++){ const yl = JY - (k + .5)*PITCH, yr = JY - k*PITCH;
      d += `M${f1(-pinR*.97)},${f1(yl)}C${f1(-pinR*.3)},${f1(yl + PITCH*.08)} ${f1(pinR*.3)},${f1(yr - PITCH*.08)} ${f1(pinR*.97)},${f1(yr)}`; } return d; }
    function pinRoots(){ let d = ''; for (let k = 0; k < 5; k++){ const yl = JY - k*PITCH, yr = JY - (k - .5)*PITCH;
      if (yr > JY) continue; d += `M${f1(-rootR)},${f1(yl)}C${f1(-rootR*.3)},${f1(yl + PITCH*.08)} ${f1(rootR*.3)},${f1(yr - PITCH*.08)} ${f1(rootR)},${f1(yr)}`; } return d; }
    function femaleThreads(){ let d = ''; for (let y = JY - 2; y > pinY0 + PITCH; y -= PITCH) for (const sg of [-1, 1]){
      const y0 = y - (sg > 0 ? PITCH/2 : 0); d += `M${f1(sg*(pinR + 3))},${f1(y0)}Q${f1(sg*rootR*.98)},${f1(y0 - PITCH/2)} ${f1(sg*(pinR + 3))},${f1(y0 - PITCH)}Z`; } return d; }
    const DROPS = [[-.45, .18], [.35, .42], [-.1, .7], [.5, .12], [-.55, .52], [.18, .86], [.02, .3], [-.3, .9]];
    const wy0 = yAt(BUTT.w0), wy1 = yAt(BUTT.w1), wr = 5*MM, balY = yAt(BUTT.bal);
    const lowerG = `<g id="kpa-lower"><g id="kpa-shaftLow">
      ${[[Y.end, YB.taper], [YB.taper, JY]].map(([a, b]) => { const c = Math.min(b, YB.foamEnd);
        return `<path d="${quad(-rs(a)+T, rs(a)-T, a, -rs(c)+T, rs(c)-T, c)}" fill="url(#kpa-foamV)"/><path d="${quad(-rs(a)+T, rs(a)-T, a, -rs(c)+T, rs(c)-T, c)}" fill="url(#kpa-cells)"/>
          <path d="${side(rs, a, b, T)}" fill="url(#kpa-wallV)"/><path d="${side(rs, a, b, T)}" fill="url(#kpa-ply1)"/>
          ${edge(rs, a, b, 0, 'rgba(237,237,237,.82)')}${edge(rs, a, b, T, 'rgba(237,237,237,.82)')}`; }).join('')}
      <path d="${quad(-rs(YB.cup)+T, rs(YB.cup)-T, YB.cup, -rs(JY)+T, rs(JY)-T, JY)}" fill="#6f6b65" stroke="rgba(237,237,237,.6)"/>
      <rect x="${f1(-pinR - 3)}" y="${f1(pinY0 - 14)}" width="${f1(2*pinR + 6)}" height="${f1(JY - pinY0 + 14)}" fill="#1c1b19"/>
      <path d="${femaleThreads()}" fill="#4a4844"/></g>
      ${ZONES.map(([a, b, k]) => buttPiece(a, b, k)).join('')}
      ${BSEG.slice(0, -1).map(sg => { const yb = sg.y0 + (sg[1] - sg[0])*MM, w = rAt(sg[1]) + 24; return `<path d="${zz(yb, w)}" fill="none" stroke="rgba(237,237,237,.55)"/><path d="${zz(yb + BGAP, w)}" fill="none" stroke="rgba(237,237,237,.55)"/>`; }).join('')}
      <rect x="${f1(-pinR - 8)}" y="${f1(yAt(18))}" width="${f1(2*pinR + 16)}" height="${f1(pinY1 - yAt(18) + 10)}" fill="#3e3628"/>
      <g id="kpa-wGrp" clip-path="url(#kpa-xray)"><rect id="kpa-wSlot" x="${f1(-wr - 6)}" y="${f1(wy0)}" width="${f1(2*wr + 12)}" height="${f1(wy1 - wy0)}" fill="#2f2920" stroke="rgba(0,0,0,.5)"/>
      <g id="kpa-wRod"><rect x="${f1(-wr)}" y="${f1(wy0 + 8)}" width="${f1(2*wr)}" height="${f1(wy1 - wy0 - 16)}" rx="6" fill="url(#kpa-steelV)" stroke="rgba(237,237,237,.6)"/></g></g>
      <rect x="${f1(-pinR)}" y="${f1(yAt(18))}" width="${f1(2*pinR)}" height="${f1(pinY1 - yAt(18))}" fill="url(#kpa-steelV)"/>
      <path d="${pinThreads(yAt(18) + 10, pinY1)}" fill="none" stroke="rgba(30,32,34,.8)"/>
      <path d="${pinOutline()}" fill="url(#kpa-steelV)" stroke="rgba(237,237,237,.55)"/>
      <path d="${pinOutline()}" fill="url(#kpa-steelSheen)" opacity=".55"/>
      <path d="${pinRoots()}" fill="none" stroke="rgba(0,0,0,.45)" stroke-width="1.6"/>
      <path d="${pinCrests()}" fill="none" stroke="rgba(255,255,255,.7)" stroke-width="1.1"/>
      <path id="kpa-pinHi" d="${pinOutline()}" fill="none" stroke="#ff6b00" stroke-width="1.6" opacity="0"/>
    </g>
    <g id="kpa-b8" opacity="0">
      <path id="kpa-face" fill="none" stroke="#ff6b00" stroke-width="2.4" stroke-linecap="round"/>
      <path id="kpa-faceL" fill="none" stroke="rgba(255,107,0,.8)"/>
      <text id="kpa-faceT" class="lbl" fill="#ff6b00">FULL FACE CONTACT</text>
      <path id="kpa-pinL" fill="none" stroke="rgba(237,237,237,.7)"/><text id="kpa-pinT" class="lbl" fill="#ededed">STAINLESS 3/8-8</text>
    </g>
    <path id="kpa-thread" fill="none" stroke="#ededed" stroke-width="1.6" stroke-linejoin="round"/><path id="kpa-threadH" fill="#ededed"/>
    <g id="kpa-b9" opacity="0">
      <path id="kpa-fulc" fill="#ff6b00"/>
      <line x1="${f1(-rAt(BUTT.bal) - 10)}" y1="${f1(balY)}" x2="${f1(rAt(BUTT.bal) + 20)}" y2="${f1(balY)}" stroke="#ff6b00" stroke-width="1.2" stroke-dasharray="6 5"/>
      <text class="lbl" x="${f1(rAt(BUTT.bal) + 28)}" y="${f1(balY)}" fill="#ff6b00">BALANCE POINT</text>
      <path d="M${f1(wr + 4)},${f1(wy0 + 40)} H${f1(rAt(BUTT.w0) + 20)}" stroke="rgba(237,237,237,.6)"/>
      <text class="lbl" x="${f1(rAt(BUTT.w0) + 28)}" y="${f1(wy0 + 40)}" fill="#ededed">BUILT-IN WEIGHT</text>
    </g>
    <g id="kpa-mass" opacity="0">
      <path id="kpa-massP" fill="url(#kpa-massG)" clip-path="url(#kpa-massClip)"/><path id="kpa-massO" fill="none" stroke="rgba(237,237,237,.55)"/>
      <path id="kpa-massL" fill="none" stroke="#ff6b00" stroke-width="1.2" stroke-dasharray="6 5"/>
    </g>
    <g id="kpa-b10" opacity="0">
      <circle id="kpa-lSrc" fill="none" stroke="#ff6b00" stroke-width="1.4"/><path id="kpa-lLine" fill="none" stroke="rgba(255,107,0,.7)"/>
      <g clip-path="url(#kpa-lensClip)"><rect id="kpa-lBg" fill="#1b1816"/><rect id="kpa-lPat" fill="url(#kpa-grainL)"/><circle id="kpa-lSpot" fill="rgba(0,0,0,.4)"/><circle id="kpa-lDrop" fill="rgba(214,226,236,.88)"/></g>
      <circle id="kpa-lRim" fill="none" stroke="rgba(237,237,237,.75)" stroke-width="1.4"/>
      <text id="kpa-lT" class="lbl" text-anchor="middle" fill="#ededed">GENUINE LEATHER</text>
    </g>
    <g id="kpa-blabels" opacity="0" fill="#b6afa5">
      ${[['STAINLESS JOINT · 3/8-8', 9, rAt(9)], ['WEIGHT BOLT', (BUTT.w0 + BUTT.w1)/2, wr], ['MAPLE', 70, rAt(70)*.5], ['LEATHER WRAP', 400, rAt(400)], ['BUTT CAP', 721, rAt(721)]].map(([t, x, x0]) => { const y = yAt(x);
        return `<path d="M${f1(x0 + 4)},${f1(y)} H${f1(rAt(x) + 26)}" stroke="rgba(154,148,138,.7)"/><circle cx="${f1(x0)}" cy="${f1(y)}" r="2.4" fill="#9a948a"/><text class="lbl" x="${f1(rAt(x) + 32)}" y="${f1(y)}">${t}</text>`; }).join('')}
    </g>`;
  
  
    /* B4 result: the same hit on the table, top view at true scale (50 in shot, 2.25 in balls, right english, level cue, firm stroke).
       Standard lands at Dr. Dave's typical 2.5°. Kyperus is placed, not measured: its centre sits half a ball radius
       from the aim (owner, 2026-10-26), so it lands inside the aim ball. Illustration, not a Kyperus figure. */
    const LN = { x:290, cb:600, ob:40 };
    LN.r = 1.125*(LN.cb - LN.ob)/50;
    const SQ = { std:2.5, ky:Math.atan(.5*LN.r/(LN.cb - LN.ob))*180/Math.PI };
    const land = a => LN.x - (LN.cb - LN.ob)*Math.tan(a*Math.PI/180);
    const laneG = `<g id="kpa-lane" opacity="0">
      <line x1="${LN.x}" y1="${LN.cb}" x2="${LN.x}" y2="${LN.ob - 52}" stroke="rgba(237,237,237,.45)" stroke-dasharray="5 5"/>
      <circle cx="${LN.x}" cy="${LN.ob}" r="${f1(LN.r)}" fill="none" stroke="rgba(237,237,237,.55)" stroke-dasharray="2 3"/>
      <text class="lbl" x="${LN.x + LN.r + 8}" y="${LN.ob}" fill="#d6d0c6">AIM</text>
      <path id="kpa-lnTS" fill="none" stroke="rgba(237,237,237,.6)" stroke-width="1.4"/><path id="kpa-lnTK" fill="none" stroke="#ff6b00" stroke-width="1.6"/>
      <circle id="kpa-lnBS" r="${f1(LN.r)}" fill="rgba(143,138,130,.35)" stroke="rgba(237,237,237,.85)" stroke-width="1.2"/>
      <circle id="kpa-lnBK" r="${f1(LN.r)}" fill="rgba(255,107,0,.25)" stroke="#ff6b00" stroke-width="1.5"/>
      <circle id="kpa-lnCB" cx="${LN.x}" cy="${LN.cb}" r="${f1(LN.r)}" fill="#ededed"/>
      <path id="kpa-lnXS" fill="none" stroke="rgba(237,237,237,.5)" stroke-dasharray="2 2"/><path id="kpa-lnXK" fill="none" stroke="rgba(255,107,0,.7)" stroke-dasharray="2 2"/>
      <path id="kpa-lnDS" fill="none" stroke="rgba(237,237,237,.85)" stroke-width="1.2"/><path id="kpa-lnDK" fill="none" stroke="#ff6b00" stroke-width="1.2"/>
      <circle id="kpa-lnCS" r=".8" fill="#ededed" opacity="0"/><circle id="kpa-lnCK" r=".8" fill="#ff6b00" opacity="0"/><circle id="kpa-lnCA" cx="${LN.x}" cy="${LN.ob}" r=".8" fill="rgba(237,237,237,.7)" opacity="0"/>
      <text id="kpa-lnLS" class="lbl" text-anchor="end" fill="#ededed">STANDARD</text><text id="kpa-lnLK" class="lbl" text-anchor="end" fill="#ff6b00">KYPERUS</text>
      <text class="lbl" x="${LN.x}" y="${f1(LN.cb + LN.r + 18)}" text-anchor="middle" fill="#d6d0c6">RIGHT ENGLISH · SAME STROKE</text>
    </g>`;
  
    /* B2 result: what reaches the hand after the ball has gone; B5: three walls side by side. Illustrative, no numbers. */
    const SC = { x:130, w:380, h:170, ys:[370, 600] };
    const WR = { x:122, ys:[268, 336, 404], r:25, th:[.14, .3, .52] };
    const scope = (y, k, label, col) => `<g><rect x="${SC.x}" y="${y}" width="${SC.w}" height="${SC.h}" fill="#060606" stroke="rgba(237,237,237,.3)"/>
        <line x1="${SC.x}" y1="${y + SC.h/2}" x2="${SC.x + SC.w}" y2="${y + SC.h/2}" stroke="rgba(237,237,237,.12)"/>
        <line x1="${SC.x + 24*SC.w/230}" y1="${y}" x2="${SC.x + 24*SC.w/230}" y2="${y + SC.h}" stroke="rgba(237,237,237,.45)" stroke-dasharray="2 3"/>
        <path id="kpa-sc${k}" fill="none" stroke="${col}" stroke-width="1.4" stroke-linejoin="round"/>
        <text class="lbl" x="${SC.x + SC.w - 10}" y="${y + 16}" text-anchor="end" fill="${col}">${label}</text></g>`;
    const ring = (k, name, note) => { const y = WR.ys[k], ri = WR.r*(1 - WR.th[k]), hot = k === 1;
      return `<g class="wr" data-k="${k}" opacity="0"><path d="M${WR.x - WR.r},${y}a${WR.r},${WR.r} 0 1 0 ${2*WR.r},0a${WR.r},${WR.r} 0 1 0 ${-2*WR.r},0Z M${WR.x - ri},${y}a${ri},${ri} 0 1 1 ${2*ri},0a${ri},${ri} 0 1 1 ${-2*ri},0Z"
          fill-rule="evenodd" fill="${hot ? '#ff6b00' : 'url(#kpa-ply1)'}" stroke="rgba(237,237,237,.7)"/>
        <text class="lbl" x="${WR.x + WR.r + 12}" y="${y - 7}" fill="${hot ? '#ff6b00' : '#ededed'}">${name}</text>
        <text class="lbl" x="${WR.x + WR.r + 12}" y="${y + 9}" fill="#c9c3b8">${note}</text></g>`; };
    const prof = y => y < JY ? rs(y) : rAt((y - JY)/MM);
    /* Butt proofs, in the space right of the cue. Feel only (Dr. Dave): none of them changes where the ball goes.
       B8: a hit's vibration runs down to the hand; a loose fit splits it at the joint, a seated steel joint passes it whole.
       B9: the cue on one finger at its balance point; the weight slides forward from the butt and the cue levels.
       B10: nine racks, sweaty palm; the hand creeps on a gloss finish and stays put on leather. All illustrative. */
    // local boxes; frame() scales each into the empty space right of the cue
    const PB = { pr9:{w:500, h:226} };
    // the whole cue on its side, tip left, thickness ×1.6 so it reads at this size
    const CU = { x0:10, len:460, y:80, th:2.8 }; CU.k = CU.len/1474;
    const cx = mm => CU.x0 + mm*CU.k, cRad = mm => (mm < 737 ? (mm <= 250 ? 12.5 : lerp(12.5, 20.4, (mm - 250)/487)) : BD(mm - 737))/2*CU.k*CU.th;
    const cBand = (a, b, fill, st) => { const pts = []; for (let m = a; m < b; m += 6) pts.push(m); pts.push(b);
      return `<path d="M${pts.map(m => f1(cx(m)) + ',' + f1(CU.y - cRad(m))).join('L')}L${pts.slice().reverse().map(m => f1(cx(m)) + ',' + f1(CU.y + cRad(m))).join('L')}Z" fill="${fill}"${st ? ` stroke="${st}"` : ''}/>`; };
    const CUFX = cx(737 + BUTT.bal), CUFY = CU.y + cRad(737 + BUTT.bal);
    const HAND = [1290, 1400];
    // B9 proof: one stroke as a trace, left to right: the cue settles at setup, runs smooth, takes the hit and goes quiet again
    const ST = { x0:24, x1:476, y:122, set:170, imp:322 };
    const pr9G = `<g id="kpa-pr9" opacity="0"><g id="kpa-pr9f">
      <rect x="0" y="0" width="500" height="226" fill="#060606" stroke="rgba(237,237,237,.3)"/>
      <text class="lbl pl" x="16" y="22" fill="#ededed">ONE STROKE</text>
      <line x1="${ST.x0}" x2="${ST.x1}" y1="${ST.y}" y2="${ST.y}" stroke="rgba(237,237,237,.16)"/>
      ${[ST.set, ST.imp + 34].map(x => `<line x1="${x}" x2="${x}" y1="${ST.y - 40}" y2="${ST.y + 40}" stroke="rgba(237,237,237,.12)"/>`).join('')}
      <line x1="${ST.imp}" x2="${ST.imp}" y1="48" y2="${ST.y + 44}" stroke="rgba(237,237,237,.45)" stroke-dasharray="2 3"/>
      <circle cx="${ST.imp + 12}" cy="${ST.y}" r="9" fill="none" stroke="rgba(237,237,237,.7)"/>
      <text class="lbl pl" x="${ST.imp}" y="40" text-anchor="middle" fill="#ededed">IMPACT</text>
      <path id="kpa-stT" fill="none" stroke="#ff6b00" stroke-width="1.6" stroke-linejoin="round"/>
      ${[['SETTLES', (ST.x0 + ST.set)/2], ['SMOOTH', (ST.set + ST.imp)/2], ['GROUNDED', (ST.imp + 34 + ST.x1)/2]].map(([w, x], k) =>
        `<text class="lbl pl stc" data-x="${x}" x="${x}" y="196" text-anchor="middle" fill="${k === 2 ? '#ff6b00' : '#d6d0c6'}">${w}</text>`).join('')}
    </g></g>`;
    const RG = { x:300, y:505, ro:64, ri:46 };
    const pr1G = `<g id="kpa-pr1" opacity="0">
      <path d="M${RG.x - RG.ro},${RG.y}a${RG.ro},${RG.ro} 0 1 0 ${2*RG.ro},0a${RG.ro},${RG.ro} 0 1 0 ${-2*RG.ro},0Z M${RG.x - RG.ri},${RG.y}a${RG.ri},${RG.ri} 0 1 1 ${2*RG.ri},0a${RG.ri},${RG.ri} 0 1 1 ${-2*RG.ri},0Z" fill-rule="evenodd" fill="#1c1c1c"/>
      <path d="M${RG.x - RG.ro},${RG.y}a${RG.ro},${RG.ro} 0 1 0 ${2*RG.ro},0a${RG.ro},${RG.ro} 0 1 0 ${-2*RG.ro},0Z M${RG.x - RG.ri},${RG.y}a${RG.ri},${RG.ri} 0 1 1 ${2*RG.ri},0a${RG.ri},${RG.ri} 0 1 1 ${-2*RG.ri},0Z" fill-rule="evenodd" fill="url(#kpa-ply1)" stroke="rgba(237,237,237,.7)"/>
      <g fill="none" stroke="#ff6b00" stroke-width="1.4" stroke-linejoin="round"><path id="kpa-r1W0"/><path id="kpa-r1W1"/><path id="kpa-r1W2"/></g>
      <path id="kpa-r1A" fill="none" stroke="#ff6b00" stroke-width="1.8" stroke-linecap="round"/><path id="kpa-r1H" fill="#ff6b00"/>
      <text class="lbl" x="${RG.x}" y="${RG.y + RG.ro + 26}" text-anchor="middle" fill="#ff6b00">FORCE SPREADS</text>
    </g>`;
    const proofsG = pr1G + pr9G + `
    <g id="kpa-pr2" opacity="0">
      <text class="lbl" x="${SC.x}" y="${SC.ys[0] - 16}" fill="#ededed">WHAT REACHES YOUR HAND</text>
      ${scope(SC.ys[0], 'H', 'HOLLOW TUBE', 'rgba(237,237,237,.8)')}${scope(SC.ys[1], 'F', 'FOAM CORE', '#ff6b00')}
      <text class="lbl" x="${SC.x + 24*SC.w/230 + 6}" y="${SC.ys[1] + SC.h - 14}" fill="#d6d0c6">BALL GONE · ~1 ms</text>
    </g>
    <g id="kpa-pr5">${ring(0, 'THIN WALL', 'LESS STABLE')}${ring(1, 'KYPERUS', 'BALANCED')}${ring(2, 'THICK WALL', 'LESS RESPONSIVE')}</g>`;
  
    const dimLine = id => `<path id="kpa-${id}" fill="none" stroke="#ff6b00" stroke-width="1.4"/>`;
    const world = `<svg id="kpa-world" xmlns="${NS}" aria-hidden="true">${defs}
      <rect x="-3000" y="-3000" width="6000" height="6000" fill="url(#kpa-grid)"/>
      <g id="kpa-b3ball" opacity="0"><circle cx="${f1(BALLC[0])}" cy="${f1(BALLC[1])}" r="${f1(BALL)}" fill="url(#kpa-ballG)" stroke="rgba(237,237,237,.55)" stroke-width="1.1"/>
        <path id="kpa-spin" fill="none" stroke="#ff6b00" stroke-width="1.6" stroke-linecap="round"/><path id="kpa-spinH" fill="#ff6b00"/></g>
      ${heroG}
      ${secG}
      ${lowerG}
      <g id="kpa-wave" fill="none" stroke="#ff6b00" stroke-width="1.5" stroke-linejoin="round"><path id="kpa-wz0"/><path id="kpa-wz1"/><path id="kpa-wf0"/><path id="kpa-wf1"/></g>
      <g id="kpa-b3arr" opacity="0" fill="none" stroke="#ff6b00" stroke-width="1.6" stroke-linecap="round">
        <path id="kpa-hit"/><path id="kpa-hitH" fill="#ff6b00" stroke="none"/><path id="kpa-fb0"/><path id="kpa-fb1"/><path id="kpa-fbH" fill="#ff6b00" stroke="none"/></g>
      <g id="kpa-b4" opacity="0">
        <rect id="kpa-holHi" x="${-BORE}" y="${Y.hol}" width="${2*BORE}" height="${Y.foam-Y.hol}" fill="rgba(255,107,0,.12)" stroke="#ff6b00" stroke-width="1.4"/>
        <path d="M${R+14},${Y.hol} H${R+22} V${Y.foam} H${R+14}" fill="none" stroke="#ff6b00" stroke-width="1.2"/>
        <text id="kpa-holT" class="lbl" x="${R+30}" y="${(Y.hol+Y.foam)/2}" fill="#ff6b00">HOLLOW FRONT</text>
      </g>
      ${laneG}
      ${proofsG}
      <g id="kpa-b5" opacity="1">${dimLine('dmL')}${dimLine('dmR')}${dimLine('dmD')}${dimLine('dmB')}
        <text id="kpa-fT" x="92" y="214" fill="#ff6b00" opacity="0" font-family="Rajdhani,sans-serif" font-weight="700">Kyperus's Formula</text></g>
      <g id="kpa-labels" opacity="0" fill="#b6afa5">
        ${[['TIP · 8 LAYERS', 30, R], ['FERRULE', 76, R], ['INSERT', 126, BORE], ['HOLLOW FRONT', 330, BORE], ['FOAM CORE', 600, BORE-14], ['CARBON WALL', 720, R]].map(([t,y,x0]) =>
          `<path d="M${x0+4},${y} H${R+26}" stroke="rgba(154,148,138,.7)"/><circle cx="${x0}" cy="${y}" r="2.4" fill="#9a948a"/><text class="lbl" x="${R+32}" y="${y}">${t}</text>`).join('')}
      </g>
    </svg>`;
  
    const art = root.querySelector('#kpa-art');
    art.innerHTML = world;
    const W = art.querySelector('#kpa-world'), $ = id => W.querySelector('#kpa-'+id);
    const lbls = [...W.querySelectorAll('.lbl')];
    lbls.forEach(t => { t.setAttribute('font-family', 'IBM Plex Mono, monospace'); t.setAttribute('dominant-baseline', 'middle'); t.setAttribute('letter-spacing', '.06em'); });
  
    /* ---------- beats ---------- */
    // cam: world box to frame; ct: share of the beat spent moving the camera in
    const CAM = {
      hero:{x:-300, y:30, w:700, h:520}, full:{x:-250, y:-40, w:520, h:960}, full2:{x:-180, y:-40, w:710, h:960},
      tip:{x:-230, y:-160, w:460, h:470}, hollow:{x:-110, y:-40, w:500, h:700, wN:570}, arrive:{x:180, y:-20, w:170, h:130}, wall:{x:-120, y:112, w:385, h:330, wN:440},
      mid:{x:-250, y:JY*.5 - 560, w:880, h:1120}, joint:{x:-250, y:JY - 760, w:880, h:1120}, bal:{x:-250, y:JY + 225*MM, w:1060, h:150*MM},
      wrap:{x:-250, y:JY + 330*MM, w:1060, h:150*MM}, wrapC:{x:-530, y:JY + 330*MM, w:1060, h:150*MM}, cue:{x:-900, y:-160, w:1800, h:2*JY + 420}
    };
    // w: share of the scroll; g: copy group (0 shaft, 1 butt); item/bul: global indexes into the copy
    const B = [
      { w:.44, cam:'hero',   g:0 },
      { w:.19, cam:'hero',   g:0, item:0, bul:0, lead:[.42,.54], text:[.48,.64] },
      { w:.22, cam:'full2',  g:0, item:0, bul:1, lead:[.5,.6],   text:[.56,.7],  ct:.2 },
      { w:.17, cam:'tip',    g:0, item:1, bul:2, lead:[.6,.72],  text:[.68,.86], ct:.24 },
      { w:.32, cam:'hollow', g:0, item:2, bul:3, lead:[.34,.44], text:[.4,.54],  ct:.16, camEnd:'arrive', tEnd:[.76,.86] },
      { w:.18, cam:'wall',   g:0, item:2, bul:4, lead:[.38,.48], text:[.44,.58], ct:.18 },
      { w:.08, cam:'mid',    g:0, ct:1 },
      { w:.10, cam:'joint',  g:1, ct:1 },
      { w:.18, cam:'joint',  g:1, item:3, bul:5, lead:[.52,.6],  text:[.56,.7] },
      { w:.18, cam:'bal',    g:1, item:4, bul:6, lead:[.62,.72], text:[.68,.84], ct:.2 },
      { w:.18, cam:'wrap',   g:1, item:5, bul:7, lead:[.5,.6],   text:[.56,.7],  ct:.2 },
      { w:.14, cam:'wrapC',  g:2, ct:.3 }
    ];
    { const tot = B.reduce((n, b) => n + b.w, 0); let acc = 0; B.forEach(b => { b.a = acc/tot; acc += b.w; b.b = acc/tot; }); }
    const ITEM_SPAN = Array.from({length:6}, (_, k) => { const bs = B.filter(b => b.item === k); return [bs[0].a, bs[bs.length - 1].b]; });
  
    const track = root.querySelector('#kpa-track'), stage = root.querySelector('#kpa-stage'), copy = root.querySelector('#kpa-copy');
    const leadSvg = root.querySelector('#kpa-lead');
    const items = [...copy.querySelectorAll('.it')], buls = [...copy.querySelectorAll('.bu')], grps = [...copy.querySelectorAll('.grp')];
    const steps = [...root.querySelectorAll('#kpa-steps .st')], stepBars = steps.map(s => s.querySelector('b')), chaps = [...root.querySelectorAll('#kpa-steps .stc')];
    const L = {};
    B.forEach((b, i) => {
      if (b.bul == null) return;
      const g = document.createElementNS(NS, 'g');
      g.innerHTML = `<polyline class="ld" pathLength="1" stroke-dasharray="1 1"/><circle class="dot" r="5"/>`;
      leadSvg.append(g); L[i] = { g, ln:g.firstChild, dot:g.lastChild };
    });
  
    const film = root.querySelector('#kpa-film'), filmV = root.querySelector('#kpa-film video'), filmT = root.querySelector('#kpa-filmT');
    const filmH = root.querySelector('#kpa-filmH'), filmRule = filmH.querySelector('i');
    let filmPaused = false;
    // a muted loop that runs past five seconds gets a stop control (WCAG 2.2.2)
    filmT.addEventListener('click', () => {
      filmPaused = !filmPaused; filmT.setAttribute('aria-pressed', filmPaused); filmT.setAttribute('aria-label', filmPaused ? 'Play the film' : 'Pause the film');
      if (filmPaused) filmV.pause(); else filmV.play().catch(() => {});
    });
    new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting) filmV.pause(); })).observe(stage);
    const stageIn = root.querySelector('#kpa-stageIn'), stepsEl = root.querySelector('#kpa-steps'), arcx = root.querySelector('#kpa-arcx');
    const arcB = [...arcx.querySelectorAll('b')], arcS = [...arcx.querySelectorAll('span')], arcLine = arcx.querySelector('.arcs');

    /* ---------- the opening title, typed on as on the homepage: ~55 ms a letter, a beat between words, a breath before the
       line under it, then a light over the spec. Its own clock, once, when the story reaches the top of the screen. ---------- */
    const ttl = root.querySelector('#kpa-ttl'), ttlH = ttl.querySelector('.ttl-h'), ttlS = ttl.querySelector('.ttl-s');
    const SHOT = { title:[.25, 2.45], sub:[2.75, 3.6], sweep:3.7 };   // seconds
    const chars = [];
    {
      const walk = n => [...n.childNodes].forEach(c => {
        if (c.nodeType === 3){
          const f = document.createDocumentFragment();
          for (const ch of c.textContent){ if (!ch.trim() && c.parentNode === ttlH){ f.append(ch); continue; } const sp = document.createElement('span'); sp.className = 'c'; sp.textContent = ch; f.append(sp); chars.push(sp); }
          c.replaceWith(f);
        } else walk(c);
      });
      walk(ttlH); walk(ttlS);
    }
    // the A, R and C of "A.R.C" in the line: they become the big letters
    const sub0 = chars.findIndex(c => ttlS.contains(c)), subCh = chars.slice(sub0), subTx = subCh.map(c => c.textContent).join('');
    const arcAt = subTx.indexOf('A.R.C'), arl = arcAt < 0 ? [] : [0, 2, 4].map(d => subCh[arcAt + d]);
    arl.forEach(c => c.classList.add('arl'));
    const caret = document.createElement('i'); caret.className = 'caret'; caret.setAttribute('aria-hidden', 'true'); ttlH.append(caret);
    const lits = [...ttlH.querySelectorAll('.lit')];
    function showTo(k){
      chars.forEach((c, j) => c.classList.toggle('on', j <= k));
      lits.forEach(l => {
        const mine = chars.filter(c => l.contains(c)), last = mine.filter(c => chars.indexOf(c) <= k).pop();
        const lr = l.getBoundingClientRect(), x = last ? last.getBoundingClientRect().right - lr.left : 0;
        l.style.clipPath = last === mine[mine.length - 1] ? 'none' : `inset(-20% ${f1(Math.max(0, lr.width - x))}px -20% 0)`;
      });
      const at = chars[Math.max(0, Math.min(k, sub0 - 1))], hr = ttlH.getBoundingClientRect(), cr = at.getBoundingClientRect();
      Object.assign(caret.style, { left:`${f1((k < 0 ? cr.left : cr.right) - hr.left + 3)}px`, top:`${f1(cr.top - hr.top + cr.height*.12)}px`, height:`${f1(cr.height*.76)}px` });
      caret.style.display = k >= sub0 ? 'none' : '';
    }
    const times = [];
    function beatT(from, to, a, b){
      const w = [];
      for (let j = from; j < to; j++){
        const c = chars[j], p = chars[j - 1];
        w.push(j === from ? 0 : 1 + (c.closest('.w') !== p.closest('.w') ? 1.4 : 0));
      }
      const tot = w.reduce((x, y) => x + y, 0) || 1; let acc = 0;
      w.forEach((v, j) => { acc += v; times[from + j] = a + (b - a)*acc/tot; });
    }
    beatT(0, sub0, ...SHOT.title); beatT(sub0, chars.length, ...SHOT.sub);
    let titleIn = false;
    function playTitle(){
      if (RM || P > .02){ showTo(chars.length - 1); caret.remove(); ttl.classList.add('swept'); return; }
      showTo(-1); caret.classList.add('idle');
      const t0 = performance.now(); let k = -1, swept = false;
      const step = now => {
        const t = (now - t0)/1000;
        let n = k; while (n + 1 < chars.length && times[n + 1] <= t) n++;
        if (n !== k){ k = n; showTo(k); }
        caret.classList.toggle('idle', t < SHOT.title[0] || k >= chars.length - 1);
        if (!swept && t >= SHOT.sweep){ swept = true; ttl.classList.add('swept'); caret.remove(); return; }
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
    const sms = [...copy.querySelectorAll('.sm')];
    // words revealed one by one with the scroll
    // data-accent: the word painted orange, as in the headings
    const words = el => {
      const ws = el.textContent.trim().split(/\s+/), a = (el.dataset.accent || '').toLowerCase();
      el.innerHTML = ws.map(w => `<span class="w${a && w.replace(/[^\w-]/g, '').toLowerCase() === a ? ' a' : ''}">${w}</span>`).join(' ');
      return [...el.querySelectorAll('.w')];
    };
    const IW = words(arcx.querySelector('.arcs')), BW = words(copy.querySelector('.grp[data-g="1"] .k-lead')), CW = words(copy.querySelector('.cl'));
    const revealW = (ws, u) => ws.forEach((w, j) => { w.style.opacity = (.14 + .86*clamp(u*ws.length - j)).toFixed(3); });
  
    // the whole cue side-on, true proportions (thickness ×1.3): lying across the stage on desktop, standing on phone
    art.insertAdjacentHTML('afterbegin', `<svg id="kpa-cueH" xmlns="${NS}" aria-hidden="true"></svg>`);
    const cueH = art.querySelector('#kpa-cueH');
    const STN = [[0, 1, 'AUTHENTIC CONNECTION'], [35, 2, 'LOW-DEFLECTION CONTROL'], [420, 0, 'ADAPTIVE RESPONSE'], [737, 3, 'ALIGNED JOINT'], [737 + BUTT.bal, 4, 'FORWARD BALANCE'], [1180, 5, 'SECURE GRIP']];
    let CH = null;
    function buildCue(){
      const horiz = !narrow, Lp = horiz ? box.w*.9 : box.h*.86, k = Lp/1474;
      const rad = mm => (mm < 737 ? (mm <= 250 ? 12.5 : lerp(12.5, 20.4, (mm - 250)/487)) : BD(mm - 737))/2*k*1.3;
      const o = horiz ? [(box.w - Lp)/2, box.h*.44] : [box.w*.22, (box.h - Lp)/2];
      const P = (mm, off) => horiz ? [o[0] + mm*k, o[1] + off] : [o[0] - off, o[1] + mm*k];
      const pt = q => f1(q[0]) + ',' + f1(q[1]);
      const run = (a, b, off) => { const m = []; const st = a < b ? 8 : -8; for (let x = a; st > 0 ? x < b : x > b; x += st) m.push(x); m.push(b); return m.map(x => P(x, off(x))); };
      const band = (a, b, fill) => `<path d="M${run(a, b, x => -rad(x)).map(pt).join('L')}L${run(b, a, x => rad(x)).map(pt).join('L')}Z" fill="${fill}"/>`;
      const hr = rad(1345)*2.5, h0 = P(HAND[0], 0), h1 = P(HAND[1], 0);
      const hand = horiz ? { x:h0[0], y:o[1] - hr, w:h1[0] - h0[0], h:2*hr } : { x:o[0] - hr, y:h0[1], w:2*hr, h:h1[1] - h0[1] };
      const fs = horiz ? 11 : 9;
      // stations: alternate above and below on desktop; all to the right on phone, nudged apart
      let lastY = -99;
      const pins = STN.map(([mm, item, name], n) => {
        const up = horiz ? n % 2 === 0 : true, e = P(mm, (up ? -1 : 1)*(rad(mm) + 6)), f = P(mm, (up ? -1 : 1)*(rad(mm) + 46));
        let lx = f[0], ly = f[1];
        if (!horiz){ lx = o[0] + rad(1474) + 58; ly = Math.max(e[1], lastY + 15); lastY = ly; }
        const line = horiz ? `M${pt(e)}L${pt(f)}` : `M${pt(e)}L${f1(lx - 18)},${f1(ly)}H${f1(lx - 6)}`;
        return `<g class="pin" opacity="0"><path d="${line}" fill="none" stroke="rgba(237,237,237,.55)"/><circle cx="${f1(e[0])}" cy="${f1(e[1])}" r="3" fill="#ff6b00"/>
          <text x="${f1(horiz ? lx - 3 : lx)}" y="${f1(horiz ? ly + (up ? -10 : 16) : ly)}" font-size="${fs}" font-family="IBM Plex Mono, monospace" letter-spacing=".06em" dominant-baseline="middle" fill="#ededed">${name}</text></g>`;
      }).join('');
      cueH.setAttribute('viewBox', `0 0 ${f1(box.w)} ${f1(box.h)}`);
      cueH.innerHTML = `${band(0, 737, '#2c2c2c')}${band(737, 755, '#c9ccd0')}${band(755, 1037, '#9c8c68')}${band(1037, 1051, '#161616')}${band(1051, 1343, '#1b1816')}${band(1343, 1474, '#121212')}
        <path d="M${run(0, 1474, x => -rad(x)).map(pt).join('L')}L${run(1474, 0, x => rad(x)).map(pt).join('L')}Z" fill="none" stroke="rgba(237,237,237,.55)"/>
        <rect class="hand" x="${f1(hand.x)}" y="${f1(hand.y)}" width="${f1(hand.w)}" height="${f1(hand.h)}" rx="${f1(Math.min(hand.w, hand.h)*.3)}" fill="rgba(237,237,237,.06)" stroke="rgba(237,237,237,.6)"/>
        <circle class="tipg" cx="${pt(P(0, 0)).split(',')[0]}" cy="${pt(P(0, 0)).split(',')[1]}" r="12" fill="none" stroke="#ff6b00" stroke-width="1.6" opacity="0"/>
        <path class="tO" pathLength="1" stroke-dasharray="1 1" fill="none" stroke="#ff6b00" stroke-width="1.8" d="M${run((HAND[0] + HAND[1])/2, 0, x => -(rad(x) + 7)).map(pt).join('L')}"/>
        <path class="tW" pathLength="1" stroke-dasharray="1 1" fill="none" stroke="#ededed" stroke-width="1.8" d="M${run(0, (HAND[0] + HAND[1])/2, x => rad(x) + 7).map(pt).join('L')}"/>
        <circle class="hO" r="3.5" fill="#ff6b00"/><circle class="hW" r="3.5" fill="#ededed"/>${pins}`;
      const q = c => cueH.querySelector(c), tO = q('.tO'), tW = q('.tW'), pinEls = [...cueH.querySelectorAll('.pin')], tip = P(0, 0);
      const lenO = tO.getTotalLength(), lenW = tW.getTotalLength(), HM = (HAND[0] + HAND[1])/2;
      let pinV = STN.map(() => 0);
      CH = {
        draw(oo, ww, tipG, handG, pin, zoom){
          tO.style.strokeDashoffset = 1 - oo; tW.style.strokeDashoffset = 1 - ww;
          const a = tO.getPointAtLength(lenO*oo), b = tW.getPointAtLength(lenW*ww);
          q('.hO').setAttribute('cx', f1(a.x)); q('.hO').setAttribute('cy', f1(a.y)); q('.hO').style.opacity = oo > .01 && oo < .99 ? 1 : 0;
          q('.hW').setAttribute('cx', f1(b.x)); q('.hW').setAttribute('cy', f1(b.y)); q('.hW').style.opacity = ww > .01 && ww < .99 ? 1 : 0;
          q('.tipg').setAttribute('opacity', tipG);
          q('.hand').setAttribute('stroke', handG > .5 ? '#ff6b00' : 'rgba(237,237,237,.6)');
          pinV = STN.map(([mm]) => pin < 0 ? 0 : clamp((pin*HM - mm)/40 + 1));
          pinEls.forEach((g, n) => g.setAttribute('opacity', pinV[n].toFixed(3)));
          cueH.style.transformOrigin = `${f1(tip[0])}px ${f1(tip[1])}px`;
          cueH.style.transform = zoom > 0 ? `scale(${(1 + 5*zoom*zoom).toFixed(3)})` : '';
        },
        pinOn: item => pinV[STN.findIndex(x => x[1] === item)] > .5
      };
    }
  
    let box = { w:1, h:1, l:0, t:0 }, narrow = false;
    function layout(){
      const s = stage.getBoundingClientRect(), a = art.getBoundingClientRect();
      if (a.width < 10) return;
      box = { w:a.width, h:a.height, l:a.left - s.left, t:a.top - s.top };
      narrow = innerWidth < 760;
      buildCue();
    }
  
    function camAt(i, t){
      // wN: a wider frame on phone so labels at phone size are not cut at the edge
      const fit = c => { const w = narrow && c.wN ? c.wN : c.w, s = Math.max(w/box.w, c.h/box.h); return { x:c.x + w/2, y:c.y + c.h/2, s }; };
      const ease = u => RM ? 1 : (u < .5 ? 4*u*u*u : 1 - Math.pow(-2*u + 2, 3)/2);
      const mix = (a, b, k) => ({ x:lerp(a.x, b.x, k), y:lerp(a.y, b.y, k), s:Math.exp(lerp(Math.log(a.s), Math.log(b.s), k)) });
      let to = fit(CAM[B[i].cam]);
      if (B[i].camEnd) to = mix(to, fit(CAM[B[i].camEnd]), ease(clamp((t - B[i].tEnd[0])/(B[i].tEnd[1] - B[i].tEnd[0]))));
      if (!i || !B[i].ct) return to;
      const prev = B[i-1], from = fit(CAM[prev.camEnd || prev.cam]);
      return mix(from, to, ease(clamp(t/B[i].ct)));
    }
  
    const heroPt = (x, y) => { const r = HROT*Math.PI/180; return [HO[0] + x*Math.cos(r) - y*Math.sin(r), HO[1] + x*Math.sin(r) + y*Math.cos(r)]; };
    const plyG = [...W.querySelectorAll('#kpa-hero [data-p]')];
    function peel(e){
      const off = i => i*PEEL*e;
      plyG.forEach((g, i) => {
        const r = HR - i*HTH, xa = -off(i), xb = -off(Math.max(0, i-1));
        const band = `M${f1(xa)},${f1(-r)} L${f1(xb)},${f1(-r)} A${f1(FX*r)},${f1(r)} 0 0 1 ${f1(xb)},${f1(r)} L${f1(xa)},${f1(r)} A${f1(FX*r)},${f1(r)} 0 0 1 ${f1(xa)},${f1(-r)} Z`;
        g.querySelectorAll('.pb').forEach(p => p.setAttribute('d', band));
        const face = ann(xa, r, r - HTH);
        g.querySelectorAll('.pf').forEach((p, k) => p.setAttribute('d', k === 2 ? ell(xa, r - HTH) : k === 3 ? ell(xa, r) : face));
      });
      $('hFoam').querySelectorAll('path').forEach(p => p.setAttribute('d', ell(-off(PL-1), HRF)));
    }
    function helix(len){
      let d = '';
      for (const [p, ph] of HX){
        let pen = false;
        for (let s=0; s<=len; s+=4){
          const f = ph + 2*Math.PI*s/p, c = Math.cos(f);
          if (c > .04){ d += (pen ? 'L' : 'M') + f1(s + FX*HR*c) + ',' + f1(HR*Math.sin(f)); pen = true; } else pen = false;
        }
      }
      return d || 'M0,0';
    }
    const arrowHead = (x, y, ang, sz) => {
      const a = ang*Math.PI/180, b = .5;
      return `M${f1(x)},${f1(y)} L${f1(x - sz*Math.cos(a - b))},${f1(y - sz*Math.sin(a - b))} L${f1(x - sz*Math.cos(a + b))},${f1(y - sz*Math.sin(a + b))} Z`;
    };
    function wave(front){
      const yEnd = lerp(Y.ins + 4, 900, front);
      for (const s of [-1, 1]){
        let d = '';
        for (let y = Y.ins + 4, k = 0; y <= Math.min(yEnd, Y.foam + 160); y += 5, k++){
          const amp = y < Y.foam ? 3 : 3*Math.exp(-(y - Y.foam)/40);
          d += (k ? 'L' : 'M') + f1(s*(R - T/2) + (k % 2 ? amp : -amp)) + ',' + f1(y);
        }
        $(s < 0 ? 'wz0' : 'wz1').setAttribute('d', d || 'M0,0');
        let e = '';
        for (let y = Y.foam, k = 0; y <= yEnd; y += 3, k++){
          const u = y - Y.foam, x = s*(BORE - 6)*Math.cos(Math.PI*u/130)*Math.exp(-u/320);
          e += (k ? 'L' : 'M') + f1(x) + ',' + f1(y);
        }
        $(s < 0 ? 'wf0' : 'wf1').setAttribute('d', e || 'M0,0');
      }
    }
    function dim(id, x0, x1, y, k, tick){
      const m = (x0 + x1)/2, h = (x1 - x0)/2*k;
      $(id).setAttribute('d', k > .01 ? `M${f1(m-h)},${y-tick} V${y+tick} M${f1(m-h)},${y} H${f1(m+h)} M${f1(m+h)},${y-tick} V${y+tick}` : '');
    }
    const show = (id, o) => { const e = $(id); e.style.opacity = o; e.style.display = o > .001 ? '' : 'none'; };
  
    let P = RM ? 1 : 0, lastBeat = -1, grainS = 0, snapP = false;
    const cells = W.querySelector('#kpa-cells');
    function frame(){
      const r = track.getBoundingClientRect();
      const target = clamp(-r.top / Math.max(1, r.height - innerHeight));
      P = RM || snapP ? target : lerp(P, target, .12); snapP = false;
      if (Math.abs(target - P) < .0004) P = target;
      const p = P;
      let i = B.findIndex(b => p < b.b); if (i < 0) i = B.length - 1;
      const t = clamp((p - B[i].a)/(B[i].b - B[i].a));
      const at = (k, tt) => i === k ? tt : 0;
  
      // camera
      const c = camAt(i, t), vw = box.w*c.s, vh = box.h*c.s;
      W.setAttribute('viewBox', `${f1(c.x - vw/2)} ${f1(c.y - vh/2)} ${f1(vw)} ${f1(vh)}`);
      if (Math.abs(c.s - grainS) > 1e-4){ grainS = c.s; cells.setAttribute('patternTransform', `scale(${c.s.toFixed(4)})`); }
      const px = (x, y) => [box.l + (x - (c.x - vw/2))/c.s, box.t + (y - (c.y - vh/2))/c.s];
      lbls.forEach(l => { l.setAttribute('font-size', f1((narrow ? 10.5 : 11)*c.s)); if (l.classList.contains('fine')) l.style.display = narrow ? 'none' : ''; });
      $('fT').setAttribute('font-size', f1(17*c.s));
      $('fT').setAttribute('dominant-baseline', 'middle');
  
      // B0-B1 hero: plies telescope out, then force paths wind round the tube
      const heroO = i < 2 ? 1 : i === 2 ? 1 - win(t, 0, .2) : 0;
      show('hero', heroO);
      if (heroO){
        const e = i === 1 ? win(t, .04, .3) : i > 1 ? 1 : 0;
        peel(e);
        $('hLight').style.opacity = $('hRim').style.opacity = 1 - sm(e*4);
        const h = i === 1 ? win(t, .2, .44) : i > 1 ? 1 : 0;
        const hx = $('helix'); hx.setAttribute('d', helix(420*h)); hx.setAttribute('stroke', i === 1 ? '#ff6b00' : 'rgba(237,237,237,.45)');
      }
      // B1 proof: one force lands on one point of the tube and spreads round the whole ring
      const p1 = i === 1 ? win(t, .6, .66) : i === 2 ? 1 - win(t, 0, .12) : 0;
      show('pr1', p1);
      if (p1){
        const hit = i === 1 ? win(t, .66, .72) : 1, sp = i === 1 ? win(t, .72, .92) : 1, s0 = c.s;
        const y0 = RG.y - RG.ro - 80, y1 = lerp(y0, RG.y - RG.ro - 4, hit);
        $('r1A').setAttribute('d', `M${RG.x},${y0}V${f1(y1)}`); $('r1H').setAttribute('d', arrowHead(RG.x, y1, 90, 10*s0));
        const a0 = -Math.PI/2 - Math.PI*sp*.999, a1 = -Math.PI/2 + Math.PI*sp*.999;
        [49.5, 55, 60.5].forEach((rk, k) => {
          const pts = [];
          for (let n = 0; n <= 160; n++){ const a = lerp(a0, a1, n/160), r = rk + 3.2*Math.sin((a + Math.PI/2)*(7 + 2*k) + k*1.7); pts.push([RG.x + r*Math.cos(a), RG.y + r*Math.sin(a)]); }
          $('r1W' + k).setAttribute('d', sp > .01 ? 'M' + pts.map(q => q.map(f1).join(',')).join('L') : '');
        });
      }
      // B2 section draws in from the tip; noise runs down the walls and smooths out in the foam
      const reveal = i < 2 ? 0 : i === 2 ? win(t, .05, .24) : 1;
      $('secClipR').setAttribute('height', f1(1300*reveal));
      show('lower', i < 2 ? 0 : 1);
      show('sec', reveal ? 1 : 0);
      const wv = i === 2 ? win(t, .22, .48) : i > 2 ? 1 : 0;
      show('wave', i === 2 ? (wv > 0 ? 1 : 0) : i === 3 ? 1 - win(t, 0, .14) : 0);
      if (i === 2 || i === 3) wave(wv);
      const lab = 0;
      show('labels', lab);
  
      // B3 connection: ball meets the tip, force in, feedback runs back down the walls
      const bo = i === 3 ? win(t, .1, .24) : i === 4 ? 1 - win(t, 0, .14) : 0;
      show('b3ball', bo);
      const cIn = i === 3 ? win(t, .16, .4) : i > 3 ? 1 : 0;
      $('b3ball').setAttribute('transform', `translate(0 ${f1(-(1 - cIn)*90)})`);
      const kick = i === 3 ? win(t, .38, .44) * (1 - .6*win(t, .46, .62)) : 0;
      $('tipG').setAttribute('transform', `translate(0 ${Y.fer}) scale(1 ${f1(1 - .07*kick)}) translate(0 ${-Y.fer})`);
      const s = c.s;
      if (i === 3 || i === 4){
        $('spin').setAttribute('d', ''); $('spinH').setAttribute('d', ''); $('hit').setAttribute('d', ''); $('hitH').setAttribute('d', ''); $('fb1').setAttribute('d', '');
        // feedback leaves the exact contact point, through the tip and insert, then down the wall
        const path = [[CONTACT[0], Y.tip + 10], [CONTACT[0], Y.ins + 4], [R - T/2, Y.ins + 40], [R - T/2, 300]];
        const segL = path.slice(1).map((q, k) => Math.hypot(q[0] - path[k][0], q[1] - path[k][1])), tot = segL.reduce((a, b) => a + b, 0);
        let left = (i === 3 ? win(t, .44, .7) : 1)*tot, d = `M${path[0].map(f1).join(',')}`, end = path[0], ang = 90;
        for (let k = 0; k < segL.length && left > 0; k++){
          const u = Math.min(1, left/segL[k]), a = path[k], b = path[k + 1];
          end = [lerp(a[0], b[0], u), lerp(a[1], b[1], u)]; ang = Math.atan2(b[1] - a[1], b[0] - a[0])*180/Math.PI;
          d += `L${end.map(f1).join(',')}`; left -= segL[k];
        }
        const on = i === 4 || win(t, .44, .7) > .02;
        $('fb0').setAttribute('d', on ? d : ''); $('fbH').setAttribute('d', on ? arrowHead(end[0], end[1], ang, 9*s) : '');
      }
      show('b3arr', i === 3 ? win(t, .38, .42) : i === 4 ? 1 - win(t, 0, .14) : 0);
  
      // B4 low-deflection: the hollow front lights, end view shows off-centre hits
      const b4 = i === 4 ? win(t, .14, .26) : i === 5 ? 1 - win(t, 0, .14) : 0;
      show('b4', b4);
  
  
      // B4 result on the table: same hit, both shafts at once, then how far each lands from the aim
      const ln = i === 4 ? win(t, .5, .56) : i === 5 ? 1 - win(t, 0, .14) : 0;
      show('lane', ln);
      if (ln){
        const u = i === 4 ? t : 1, go = sm(clamp((u - .56)/.18));
        for (const [k, a] of [['S', SQ.std], ['K', SQ.ky]]){
          const x = lerp(LN.x, land(a), go), y = lerp(LN.cb, LN.ob, go);
          $('lnB' + k).setAttribute('cx', f1(x)); $('lnB' + k).setAttribute('cy', f1(y));
          $('lnB' + k).style.opacity = go > .01 ? 1 : 0;
          $('lnT' + k).setAttribute('d', go > .002 ? `M${LN.x},${LN.cb}L${f1(x)},${f1(y)}` : '');
        }
        $('lnCB').style.opacity = go > .01 ? 0 : 1;
        const dk = win(u, .86, .93), lo = win(u, .9, .97), tk = 3;
        const dimAt = (y, x1) => dk > .01 ? `M${LN.x},${y - tk}V${y + tk}M${LN.x},${y}H${f1(lerp(LN.x, x1, dk))}M${f1(lerp(LN.x, x1, dk))},${y - tk}V${y + tk}` : '';
        const yS = LN.ob - LN.r - 20, yK = LN.ob - LN.r - 8, xs = land(SQ.std), xk = land(SQ.ky);
        $('lnDS').setAttribute('d', dimAt(yS, xs)); $('lnDK').setAttribute('d', dimAt(yK, xk));
        // extension lines: from each ball's centre straight down to its dimension
        $('lnXS').setAttribute('d', dk > .01 ? `M${f1(xs)},${LN.ob}V${yS - tk}` : '');
        $('lnXK').setAttribute('d', dk > .01 ? `M${f1(xk)},${LN.ob}V${yK - tk}` : '');
        $('lnCS').setAttribute('cx', f1(xs)); $('lnCS').setAttribute('cy', LN.ob);
        $('lnCK').setAttribute('cx', f1(xk)); $('lnCK').setAttribute('cy', LN.ob);
        ['lnCS', 'lnCK', 'lnCA'].forEach(id => $(id).setAttribute('opacity', dk));
        [['lnLS', xs, yS], ['lnLK', xk, yK]].forEach(([id, x, y]) => { $(id).setAttribute('x', f1(Math.min(xs, xk) - 8)); $(id).setAttribute('y', y); $(id).style.opacity = lo; });
      }
      // B2 result: after the ball has gone, the hollow tube keeps ringing; the foam core lets the clean signal through
      const p2 = i === 2 ? win(t, .66, .72) : i === 3 ? 1 - win(t, 0, .12) : 0;
      show('pr2', p2);
      if (p2){
        const sig = (k, u) => {
          const y0 = SC.ys[k === 'H' ? 0 : 1] + SC.h/2, pts = [];
          for (let x = 0; x <= SC.w*u; x += 1.5){
            let v;
            const xn = x*230/SC.w, a = SC.h/120;
            if (xn < 24) v = -46*a*Math.sin(Math.PI*xn/24)*Math.exp(-xn/36);
            else { const q = xn - 24; v = a*(24*Math.sin(q*.36)*Math.exp(-q/(k === 'H' ? 190 : 46)) + (k === 'H' ? 9*Math.sin(q*2.4)*Math.exp(-q/220) : 0)); }
            pts.push(f1(SC.x + x) + ',' + f1(y0 + v));
          }
          $('sc' + k).setAttribute('d', pts.length > 1 ? 'M' + pts.join('L') : '');
        };
        sig('H', i === 2 ? win(t, .72, .84) : 1); sig('F', i === 2 ? win(t, .84, .96) : 1);
      }
      // B5 result: three walls side by side, they appear once, the balanced one lights
      W.querySelectorAll('#kpa-pr5 .wr').forEach(g => {
        const k = +g.dataset.k;
        g.setAttribute('opacity', i === 5 ? win(t, .62 + k*.08, .7 + k*.08) : i === 6 ? 1 - win(t, 0, .12) : 0);
      });
  
      // B5 wall: dimension the wall and the bore, then name it
      const fm = i === 5 ? win(t, .14, .32) : i === 6 ? 1 - win(t, 0, .14) : 0;
      const fk = i === 5 ? win(t, .14, .32) : 1;
      show('b5', fm ? 1 : 0); $('b5').style.opacity = i === 6 ? fm : 1;
      dim('dmL', -R, -BORE, 170, fk, 6); dim('dmR', BORE, R, 170, fk, 6); dim('dmD', -R, R, 250, fk, 6);
      const bk = i === 5 ? win(t, .28, .36) : 1;
      $('dmB').setAttribute('d', bk > .02 ? `M${R+6},170 H${R+18} V${f1(lerp(170, 250, bk))} M${R+18},210 H${R+28}` : '');
      if (bk > .98) $('dmB').setAttribute('d', `M${R+6},170 H${R+18} V250 H${R+6} M${R+18},210 H${R+28}`);
      $('fT').setAttribute('opacity', i === 5 ? win(t, .32, .4) : i === 6 ? 1 : 0);
      $('fT').setAttribute('x', R + 32); $('fT').setAttribute('y', 210);
  
  
      // the thread: feedback rides the wall down from the shaft to the hand (bridge onward)
      let th = -1;
      if (i === 6 || i === 7) th = Math.min(JY - 4, c.y + vh*.22);
      else if (i === 8) th = lerp(JY - 4, yAt(60), win(t, .46, .58));
      else if (i === 9) th = lerp(yAt(60), balY, win(t, .04, .3));
      else if (i === 10) th = lerp(balY, yAt(420), win(t, .04, .3));
      show('thread', th > 0 ? (i === 6 ? win(t, 0, .1) : 1) : 0); show('threadH', th > 0 ? (i === 6 ? win(t, 0, .1) : 1) : 0);
      if (th > 0){
        const y0 = Math.max(300, c.y - vh), pts = [];
        for (let y = y0; y < th; y += 30) pts.push([prof(y) - 6, y]);
        pts.push([prof(th) - 6, th]);
        $('thread').setAttribute('d', 'M' + pts.map(q => q.map(f1).join(',')).join('L'));
        $('threadH').setAttribute('d', arrowHead(prof(th) - 6, th + 2, 90, 10*s));
      }
      // B8 joint: the shaft lifts off, comes down the axis and seats; the whole face lights, then the thread runs through
      show('b8', i === 8 ? 1 : i === 9 ? 1 - win(t, 0, .14) : 0);
      $('pinHi').setAttribute('opacity', 0);
      if (i === 8) $('shaftLow').setAttribute('transform', `translate(0 ${f1(-win(t, .03, .14)*(1 - win(t, .2, .34))*34*MM)})`);
      else $('shaftLow').removeAttribute('transform');
      if (i === 8 || i === 9){
        const fc = i === 8 ? win(t, .36, .46) : 1, ft = i === 8 ? win(t, .42, .5) : 1;
        $('face').setAttribute('d', fc > .01 ? `M${f1(-RJ*fc)},${f1(JY)}H${f1(RJ*fc)}` : '');
        $('faceL').setAttribute('d', `M${f1(RJ + 4)},${f1(JY)}L${f1(RJ + 30*s)},${f1(JY - 36*s)}H${f1(RJ + 44*s)}`);
        $('faceL').style.opacity = ft;
        $('faceT').setAttribute('x', f1(RJ + 50*s)); $('faceT').setAttribute('y', f1(JY - 36*s)); $('faceT').style.opacity = ft;
      }
      const pl = i === 8 ? win(t, .08, .14)*(1 - win(t, .3, .36)) : 0, py = JY - 10*MM;
      $('pinL').setAttribute('d', `M${f1(pinR + 4)},${f1(py)}H${f1(RJ + 44*s)}`); $('pinL').style.opacity = pl;
      $('pinT').setAttribute('x', f1(RJ + 50*s)); $('pinT').setAttribute('y', f1(py)); $('pinT').style.opacity = pl;
      // proofs: fit the local box into the space right of the cue, keep labels at screen size
      const fitProof = (id, pinY) => {
        const pb = PB[id], fs = (narrow ? 10.5 : 11)*c.s;
        // phone: an anchored panel takes the whole width of the frame (it sits over the plain sleeve, below the labels)
        const wide = narrow && pinY, xL = wide ? c.x - vw/2 + 12*c.s : prof(c.y) + 54 + 6*.62*fs + 18*c.s, xR = c.x + vw/2 - (wide ? 12 : 18)*c.s, yA = c.y - vh/2 + 30*c.s, yB = c.y + vh/2 - 30*c.s;
        const k = Math.min((xR - xL)/pb.w, (yB - (pinY ? pinY[1] : yA))/pb.h, 560*c.s/pb.w);
        $(id + 'f').setAttribute('transform', `translate(${f1(xL + (xR - xL - pb.w*k)/2)} ${f1(pinY ? pinY[1] - pinY[0]*k : (yA + yB)/2 - pb.h*k/2)}) scale(${k.toFixed(4)})`);
        $(id).querySelectorAll('.pl').forEach(l => l.setAttribute('font-size', f1(fs/k)));
        return k;
      };
      // B9 balance: the maple goes see-through and shows the weight that is already inside, then the balance line
      show('b9', i === 9 ? win(t, .3, .4) : i === 10 ? 1 - win(t, 0, .14) : 0);
      const bx = -rAt(BUTT.bal) - 12;
      $('fulc').setAttribute('d', `M${f1(bx)},${f1(balY)} L${f1(bx - 20*s)},${f1(balY - 10*s)} L${f1(bx - 20*s)},${f1(balY + 10*s)} Z`);
      const xr = i < 9 ? 0 : i === 9 ? win(t, .1, .3) : 1;
      $('xrayR').setAttribute('y', f1(wy0 - 10)); $('xrayR').setAttribute('height', f1(xr*(wy1 - wy0 + 20)));
      show('wGrp', xr > 0 ? 1 : 0);
      $('wRod').querySelector('rect').setAttribute('stroke', i === 9 ? '#ff6b00' : 'rgba(237,237,237,.6)');
      // B9 proof: the whole cue lowers onto one point and lies level there, right where the built-in weight sits
      show('mass', 0);
      const p9 = i === 9 ? win(t, .34, .42) : i === 10 ? 1 - win(t, 0, .14) : 0;
      show('pr9', p9);
      if (p9){
        fitProof('pr9', [0, balY + (narrow ? 50 : 70)*s]);  // a panel just under the balance line, clear of both labels
        const u = i === 9 ? win(t, .42, .66) : 1, xe = lerp(ST.x0, ST.x1, u), pts = [];
        for (let x = ST.x0; x <= xe; x += 1.5){
          let v = 0;
          if (x < ST.set) v = 26*Math.exp(-(x - ST.x0)/34)*Math.sin((x - ST.x0)*.2);
          else if (x >= ST.imp - 6){ const q = x - ST.imp; v = -34*Math.exp(-Math.pow(q/5, 2)) + (q > 0 ? 9*Math.exp(-q/16)*Math.sin(q*.55) : 0); }
          pts.push(f1(x) + ',' + f1(ST.y + v));
        }
        $('stT').setAttribute('d', pts.length > 1 ? 'M' + pts.join('L') : '');
        $('pr9').querySelectorAll('.stc').forEach(l => l.style.opacity = sm((xe - +l.dataset.x + 30)/40));
      }
      // B10 grip: the leather wraps on; a lens on the grain, one drop lands and soaks in
      $('wrapClipR').setAttribute('y', f1(yAt(314)));
      $('wrapClipR').setAttribute('height', f1((i < 10 ? 0 : i === 10 ? win(t, .1, .4) : 1)*(yAt(606) - yAt(314))));
      const ga = i === 10 ? win(t, .3, .42) : i === 11 ? 1 - win(t, 0, .14) : 0;
      show('b10', ga);
      if (ga){
        const fs = (narrow ? 10.5 : 11)*s, xr0 = rAt(420) + 54 + 5*.62*fs + 30*s, xR = c.x + vw/2 - 20*s;
        const rL = Math.min((xR - xr0)/2, vh*.28), lx = xr0 + (xR - xr0)/2, ly = c.y - 10*s;
        const sx = rAt(420)*.35, sy = yAt(420), sr = 16*s;
        $('lSrc').setAttribute('cx', f1(sx)); $('lSrc').setAttribute('cy', f1(sy)); $('lSrc').setAttribute('r', f1(sr));
        $('lLine').setAttribute('d', `M${f1(sx + sr)},${f1(sy)}L${f1(lx - rL)},${f1(ly)}`);
        ['lensC', 'lRim'].forEach(id => { $(id).setAttribute('cx', f1(lx)); $(id).setAttribute('cy', f1(ly)); $(id).setAttribute('r', f1(rL)); });
        ['lBg', 'lPat'].forEach(id => { $(id).setAttribute('x', f1(lx - rL)); $(id).setAttribute('y', f1(ly - rL)); $(id).setAttribute('width', f1(2*rL)); $(id).setAttribute('height', f1(2*rL)); });
        W.querySelector('#kpa-grainL').setAttribute('patternTransform', `translate(${f1(lx)} ${f1(ly)}) scale(${(rL/150).toFixed(3)})`);
        const fall = i === 10 ? win(t, .64, .74) : 1, soak = i === 10 ? win(t, .74, .94) : 1;
        const dr = lerp(rL*.11, rL*.3, soak);
        $('lDrop').setAttribute('cx', f1(lx)); $('lDrop').setAttribute('cy', f1(lerp(ly - rL*1.3, ly, fall))); $('lDrop').setAttribute('r', f1(dr));
        $('lDrop').setAttribute('opacity', f1((fall > .01 ? 1 : 0)*(1 - soak)*.9));
        $('lSpot').setAttribute('cx', f1(lx)); $('lSpot').setAttribute('cy', f1(ly)); $('lSpot').setAttribute('r', f1(rL*.34));
        $('lSpot').setAttribute('opacity', f1(Math.sin(Math.PI*soak)*.9));
        $('lT').setAttribute('x', f1(lx)); $('lT').setAttribute('y', f1(ly + rL + 24*s));
      }
      show('blabels', i === 11 ? win(t, .38, .6) : 0);
  
      // intro: the title (typed on by its own clock) lifts away; the A, R and C of "it's A.R.C™ Technology." rise out of
      // the line into the three words, the words write on, the line under them, then the drawing comes up
      if (!titleIn && (RM || r.top < innerHeight*.2)){ titleIn = true; playTitle(); }
      ttl.style.display = i === 0 && t < .34 ? '' : 'none';
      if (i === 0 && t < .34){
        const out = win(t, .06, .18);
        ttlH.style.opacity = 1 - out; ttlH.style.transform = `translateY(${f1(-40*out)}px)`;
        ttlS.style.setProperty('--o', (1 - win(t, .1, .18)).toFixed(3));
        ttlS.style.setProperty('--arl', (1 - win(t, .15, .19)).toFixed(3));
      }
      W.style.opacity = i === 0 ? win(t, .79, .9) : i === 11 ? 1 - win(t, .4, .66) : 1;
      if (i === 0 && t < .85){
        arcx.style.display = '';
        const o = win(t, .78, .84);
        arcx.style.opacity = 1 - o; arcx.style.transform = o ? `translateY(${f1(-30*o)}px) scale(${(1 - .06*o).toFixed(3)})` : '';
        // where each small letter sits now, measured against the big letter's own box (offsets ignore transforms)
        const fly = t < .32 ? win(t, .15, .32) : 1, sr = stage.getBoundingClientRect();
        arcB.forEach((b, r) => {
          const f = win(t, .15 + r*.01, .19 + r*.01);
          b.style.opacity = f.toFixed(3); b.style.color = `rgba(255,107,0,${f.toFixed(3)})`;
          const from = arl[r];
          if (fly >= 1 || !from){ b.style.transform = ''; return; }
          const fr = from.getBoundingClientRect(), bx = arcx.offsetLeft + b.offsetLeft + b.offsetWidth/2, by = arcx.offsetTop + b.offsetTop + b.offsetHeight/2;
          const dx = fr.left + fr.width/2 - sr.left - bx, dy = fr.top + fr.height/2 - sr.top - by;
          const s0 = parseFloat(getComputedStyle(from).fontSize)/parseFloat(getComputedStyle(b).fontSize), u = 1 - Math.pow(1 - fly, 3);
          b.style.transform = `translate(${f1(dx*(1 - u))}px, ${f1(dy*(1 - u))}px) scale(${lerp(s0, 1, u).toFixed(4)})`;
        });
        arcS.forEach((sp, r) => { sp.style.clipPath = `inset(0 ${f1((1 - win(t, .28 + r*.04, .36 + r*.04))*100)}% 0 0)`; });
        arcLine.style.opacity = win(t, .44, .48).toFixed(3);
      } else arcx.style.display = 'none';
      copy.style.opacity = i === 0 ? win(t, .82, .9) : 1;
      stepsEl.style.opacity = i === 0 ? win(t, .84, .94) : 1;
      const wp = i === 0 ? clamp((t - .46)/.18) : 1;
      revealW(IW, wp);
      revealW(BW, i < 7 ? 0 : i === 7 ? clamp((t - .05)/.6) : 1);
      revealW(CW, i < 11 ? 0 : clamp((t - .06)/.3));
      // outro: the drawing fades into the studio film of the same cue, which opens to the whole screen as "Kyperus in motion"
      cueH.style.display = 'none';
      const fo = i === 11 ? win(t, .14, .3) : 0, fe = i === 11 ? win(t, .42, .8) : 0;
      film.style.visibility = fo > .001 ? 'visible' : 'hidden'; film.style.opacity = fo;
      if (fo > .001){
        const sw = stage.clientWidth, sh = stage.clientHeight;
        // start: the cue's outline on screen, run the full height; end: the whole screen (desktop) or a full-width 16:9 band (phone)
        const yT = c.y - vh/2, yB = c.y + vh/2, [aL, aT] = px(-prof(yT), yT), [bL, bB] = px(-prof(yB), yB), [aR] = px(prof(yT), yT), [bR] = px(prof(yB), yB);
        const ez = 1 - Math.pow(1 - fe, 3);
        const end = narrow ? { t:(sh - sw*9/16)/2 - 40, b:(sh + sw*9/16)/2 - 40, l:0, r:sw } : { t:0, b:sh, l:0, r:sw };
        // phone: the window stays inside the drawing's frame so it never runs over the copy below
        const yt = lerp(narrow ? box.t : Math.min(0, aT), end.t, ez), yb = lerp(narrow ? box.t + box.h : Math.max(sh, bB), end.b, ez);
        film.style.clipPath = `polygon(${f1(lerp(aL, end.l, ez))}px ${f1(yt)}px, ${f1(lerp(aR, end.r, ez))}px ${f1(yt)}px, ${f1(lerp(bR, end.r, ez))}px ${f1(yb)}px, ${f1(lerp(bL, end.l, ez))}px ${f1(yb)}px)`;
        filmV.style.transform = `scale(${lerp(1.22, 1, ez).toFixed(4)})`;
        if (narrow){ filmV.style.top = f1(end.t) + 'px'; filmV.style.height = f1(end.b - end.t) + 'px'; filmV.style.bottom = 'auto'; }
        else { filmV.style.top = filmV.style.height = filmV.style.bottom = ''; }
        if (!RM && filmV.paused && !filmPaused) filmV.play().catch(() => {});
      } else if (!filmV.paused) filmV.pause();
      copy.style.opacity = i === 11 ? 1 - win(t, .4, .52) : copy.style.opacity;
      if (narrow){
        const ENTER = [6, 7], EXIT = [5, 6];
        let k = +copy.style.opacity;
        if (ENTER.includes(i)) k *= win(t, .02, .16);
        if (EXIT.includes(i)) k *= 1 - win(t, .84, .98);
        copy.style.opacity = k.toFixed(3);
      }
      const fc = i === 11 ? win(t, .84, .96) : 0;
      filmH.style.opacity = fc; filmRule.style.transform = `scaleX(${fc.toFixed(3)})`;
      const ft = i === 11 ? win(t, .88, .98) : 0;
      filmT.style.opacity = ft; filmT.style.visibility = ft > .01 ? 'visible' : 'hidden';
  
      // leaders: from the part to its bullet
      const anchors = {
        1: heroPt(-1.5*PEEL, -(HR - 2*HTH)*.72),
        2: [-BORE + 14, Y.foam + 34], 3: [-R, 30], 4: [-BORE + 6, 300], 5: [-R, 170],
        8: [-rAt(9), yAt(9)], 9: [-wr, (wy0 + wy1)/2], 10: [-rAt(420), yAt(420)]
      };
      const cr = copy.getBoundingClientRect(), sr = stage.getBoundingClientRect();
      for (const k in L){
        const b = B[k], bul = buls[b.bul], Lk = L[k];
        let d = 0;
        if (p >= b.a && p < b.b) d = win(t, b.lead[0], b.lead[1]);
        else if (p >= b.b) d = 1 - sm((p - b.b)/.012);
        const live = d > .001 && i <= +k + 1 && !(i === +k + 1 && t > .2);
        Lk.g.style.display = live ? '' : 'none';
        // a beat that ends on a second framing hands its leader off before the camera moves
        Lk.g.style.opacity = b.camEnd ? (i === +k ? 1 - win(t, b.tEnd[0] - .03, b.tEnd[0] + .02) : i > +k ? 0 : 1) : 1;
        if (!live) continue;
        const [ax, ay] = px(...anchors[k]);
        Lk.dot.setAttribute('cx', f1(ax)); Lk.dot.setAttribute('cy', f1(ay));
        if (narrow){ Lk.ln.style.display = 'none'; Lk.dot.style.opacity = d; continue; }
        Lk.ln.style.display = '';
        const br = bul.getBoundingClientRect();
        const tx = cr.right - sr.left + 18, ty = br.top - sr.top + 12;
        const elbow = Math.max(tx + 26, ax - Math.abs(ay - ty)*.9 - 10);
        Lk.ln.setAttribute('points', `${f1(ax)},${f1(ay)} ${f1(elbow)},${f1(ty)} ${f1(tx)},${f1(ty)}`);
        Lk.ln.style.strokeDashoffset = 1 - (p >= b.b ? 1 : d);
        Lk.ln.style.opacity = p >= b.b ? d : 1;
        Lk.dot.style.opacity = p >= b.b ? d : sm(d*4);
      }
  
      // copy: accordion follows the beat, bullets arrive after their leader
      if (i !== lastBeat){
        lastBeat = i;
        items.forEach((it, k) => it.classList.toggle('open', B[i].item === k));
        copy.classList.toggle('intro', i === 0 || i === 7 || (narrow && innerHeight >= 760 && (i === 1 || i === 8)));
        copy.classList.toggle('summary', i === 6);
        copy.classList.toggle('closing', i === 11);
        stepsEl.style.visibility = B[i].g > 1 ? 'hidden' : '';
        grps.forEach(g => g.classList.toggle('off', +g.dataset.g !== B[i].g));
      }
      buls.forEach((bu, j) => {
        const b = B.find(x => x.bul === j);
        let rv = 0, op = 0;
        if (p >= b.a && p < b.b){ rv = win(t, b.text[0], b.text[1]); op = rv; }
        else if (p >= b.b){ rv = 1; const k = sm((p - b.b)/.015); op = narrow ? 1 - k : lerp(1, .62, k); }
        bu.style.opacity = op;
        bu.style.transform = `translateY(${f1((1 - rv)*12)}px)`;
        bu.style.filter = RM || rv >= 1 ? 'none' : `blur(${f1((1 - rv)*4)}px)`;
      });
      navUpdate(target);
      // progress of each part: the phone's bars
      steps.forEach((st, n) => {
        const [a, b] = ITEM_SPAN[n], v = clamp((p - a)/(b - a));
        stepBars[n].style.transform = `scaleX(${v.toFixed(3)})`;
        st.classList.toggle('on', B[i].item === n); st.classList.toggle('past', p >= b);
        items[n].classList.toggle('past', p >= b);
      });
      chaps.forEach((c, g) => c.classList.toggle('on', B[i].g === g));
      if (onScreen) requestAnimationFrame(frame); else running = false;
    }
  
    /* ---------- moving without scrolling: one button plays the next scene and rests on it ----------
       One row at the foot of the stage, centred: Top · back · next · Skip. The two notched buttons step through the scenes,
       the next one's outline is the story's progress; the words leave the story, up or down. The page's back-to-top steps
       aside while the story holds the screen. */
    const ITEM_NAMES = ['Adaptive Response', 'Authentic Connection', 'Low-Deflection Control', 'Aligned Joint', 'Forward Balance', 'Secure Grip'];
    const STOP_NAMES = ['Adaptive Response', 'Foam Core', 'Authentic Connection', 'Low-Deflection', 'Wall Balance', 'Aligned Joint', 'Forward Balance', 'Secure Grip', 'In Motion'];
    // the shot list: one stop where each bullet's scene is complete, then the film. A press plays the scenes between at a pace
    // set by how much story they hold (their share of the scroll), so a long scene is never rushed and a short one never drags
    // where a beat rests: near its end, except on a phone where the copy of the last shaft beat fades out before the butt
    // (EXIT in the frame), so it rests before the fade
    const restAt = k => k === B.length - 1 ? .999 : B[k].a + (B[k].b - B[k].a)*(narrow && k === 5 ? .855 : .94);
    // the last beat rests twice: on the closing line over the cue's outline (all in by t .36, gone from .4), then on the film
    const ARC_T = .7, arcName = [...arcx.querySelectorAll('div')].map(d => d.textContent.trim()).join(' ') || 'A.R.C';
    const CLOSE_T = .37, closeName = (copy.querySelector('.grp[data-g="2"] .k-eyebrow') || {}).textContent || 'Closing';
    const STOPS = [];
    { let from = 0;
      const ms = w => Math.round(clamp(900 + w*6000, 1500, 3200));
      // the opening rests once, on the three words and their line (all in by t .64, gone from .78)
      STOPS.push([0, arcName, ms(B[0].w*ARC_T), B[0].a + (B[0].b - B[0].a)*ARC_T]);
      let carry = B[0].w*(1 - ARC_T); from = 1;
      B.forEach((b, k) => {
        if (b.bul == null && k !== B.length - 1) return;
        let w = B.slice(from, k).reduce((n, x) => n + x.w, 0) + carry; carry = 0;
        if (k === B.length - 1){
          STOPS.push([k, closeName.trim(), ms(w + b.w*CLOSE_T), b.a + (b.b - b.a)*CLOSE_T]);
          w = 0; b = { w:b.w*(1 - CLOSE_T) };
        }
        STOPS.push([k, STOP_NAMES[STOPS.length - 1 - (k === B.length - 1)], ms(w + b.w), restAt(k)]); from = k + 1;
      }); }
    const stopQ = k => STOPS[k][3];
    const ITEM_STOP = ITEM_SPAN.map((_, n) => B.findIndex(x => x.item === n));
    const nx = root.querySelector('#kpa-nx'), pv = root.querySelector('#kpa-pv'), skip = root.querySelector('#kpa-skip'), topB = root.querySelector('#kpa-top'), nxRing = root.querySelector('#kpa-nxRing');
    const span = () => { const top = track.getBoundingClientRect().top + scrollY; return [top, track.offsetHeight - innerHeight]; };
    const scrollAt = (q, [top, len] = span()) => top + q*len;
    const yOut = () => track.getBoundingClientRect().top + scrollY + track.offsetHeight;
    // our own glide: a press plays the scenes between at an even pace (eased only at both ends) and stops exactly on the stop
    let glideTo = null, glideId = 0, lastInput = -1e9, lastPress = -1e9;
    function glide(y, dur){
      cancelAnimationFrame(glideId);
      const y0 = scrollY, d = y - y0, ease = k => .5 - Math.cos(Math.PI*k)/2;
      if (RM || Math.abs(d) < 2){ glideTo = null; scrollTo({ top:y, behavior:'instant' }); return; }
      dur = dur || clamp(Math.abs(d)/innerHeight*560, 900, 2000);
      const t0 = performance.now(); glideTo = y;
      const step = now => { const k = clamp((now - t0)/dur); scrollTo({ top:y0 + d*ease(k), behavior:'instant' }); if (k < 1) glideId = requestAnimationFrame(step); else glideTo = null; };
      glideId = requestAnimationFrame(step);
    }
    const goP = q => glide(scrollAt(q));
    /* a title, a chapter or a bar: the story cuts to the start of that scene and plays it through to its rest, the way a
       press of Next would, instead of racing through every scene between. The next scene along simply plays on. */
    let cutId = 0;
    const fadeEls = [art, leadSvg];   // the drawing dips; the copy follows the beat on its own
    function jumpTo(k){
      lastPress = performance.now();
      const sp = span(), q = restAt(k), s = STOPS.findIndex(x => Math.abs(x[3] - q) < 1e-6);
      if (s < 0) return goP(q);
      const y = scrollAt(q, sp), prev = s ? scrollAt(stopQ(s - 1), sp) : sp[0], from = glideTo !== null ? glideTo : scrollY;
      if (Math.abs(y - from) < 4) return;
      if (from >= prev - 4 && from < y) return glide(y, STOPS[s][2]*clamp((y - from)/Math.max(1, y - prev), .45, 1));
      const y0 = scrollAt(B[k].a + 1e-4, sp), dur = STOPS[s][2]*clamp((y - y0)/Math.max(1, y - prev), .6, 1);
      if (RM) return glide(y);
      stopGlide(); clearTimeout(cutId); glideTo = y;
      // the copy dips with the drawing (the stylesheet's .cutting), so the chapters swap unseen instead of crossfading
      root.classList.add('cutting');
      fadeEls.forEach(e => { e.style.transition = 'opacity 160ms cubic-bezier(.23, 1, .32, 1)'; e.style.opacity = 0; });
      cutId = setTimeout(() => {
        cutId = 0;
        scrollTo({ top:y0, behavior:'instant' }); snapP = true;
        glide(y, dur);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          root.classList.remove('cutting'); root.classList.add('cut-in'); setTimeout(() => root.classList.remove('cut-in'), 320);
          fadeEls.forEach(e => { e.style.transition = 'opacity 280ms cubic-bezier(.23, 1, .32, 1)'; e.style.opacity = ''; });
        }));
      }, 170);
    }
    // the visitor takes over: their own scroll, touch or key stops a glide
    const stopGlide = () => {
      if (cutId){ clearTimeout(cutId); cutId = 0; root.classList.remove('cutting'); fadeEls.forEach(e => { e.style.opacity = ''; }); }
      if (glideTo !== null){ cancelAnimationFrame(glideId); glideTo = null; }
    };
    for (const ev of ['wheel', 'touchstart']) addEventListener(ev, stopGlide, { passive:true });
    addEventListener('keydown', e => { if (!e.target.closest || !e.target.closest('button, a, input, select, textarea')) stopGlide(); });
    for (const ev of ['wheel', 'touchstart', 'touchmove', 'keydown']) addEventListener(ev, () => { lastInput = performance.now(); }, { passive:true });
    const nextIndex = () => {
      const from = glideTo !== null ? glideTo : scrollY, sp = span(), k = STOPS.findIndex((_, j) => scrollAt(stopQ(j), sp) > from + 4);
      return k < 0 ? STOPS.length : k;
    };
    // a press plays on to the next scene; part way into one, it takes the share of it that is left; after the film it leaves
    // Top leaves the story upward in one cut: the stage dips, the page is at its top, nothing plays backwards
    function toTop(){
      stopGlide(); lastPress = performance.now();
      if (RM){ scrollTo({ top:0, behavior:'instant' }); return; }
      stage.style.transition = 'opacity 160ms cubic-bezier(.23, 1, .32, 1)'; stage.style.opacity = 0;
      setTimeout(() => { scrollTo({ top:0, behavior:'instant' }); stage.style.opacity = ''; stage.style.transition = ''; }, 170);
    }
    topB.addEventListener('click', toTop);
    // the stop behind where the visitor is (or the start of the story, before the first stop); -2 when there is none
    const prevIndex = () => {
      const from = glideTo !== null ? glideTo : scrollY, sp = span();
      for (let j = STOPS.length - 1; j >= 0; j--) if (scrollAt(stopQ(j), sp) < from - 4) return j;
      return from > sp[0] + 4 ? -1 : -2;
    };
    // the back button undoes one scene at the pace the next button plays it
    pv.addEventListener('click', () => {
      lastPress = performance.now();
      const j = prevIndex(); if (j === -2) return;
      const sp = span(), y = j >= 0 ? scrollAt(stopQ(j), sp) : sp[0], from = glideTo !== null ? glideTo : scrollY;
      const nextQ = STOPS[j + 1] ? scrollAt(stopQ(j + 1), sp) : from, ms = STOPS[j + 1] ? STOPS[j + 1][2] : 1100;
      glide(y, ms*clamp((from - y)/Math.max(1, nextQ - y), .45, 1));
    });

    nx.addEventListener('click', () => {
      lastPress = performance.now();
      const k = nextIndex(), sp = span();
      if (k >= STOPS.length) return glide(yOut(), 1100);
      const y = scrollAt(stopQ(k), sp), from = glideTo !== null ? glideTo : scrollY, prev = k ? scrollAt(stopQ(k - 1), sp) : sp[0];
      glide(y, STOPS[k][2]*clamp((y - from)/Math.max(1, y - prev), .45, 1));
    });
    skip.addEventListener('click', () => { lastPress = performance.now(); glide(yOut(), 1100); });
    // titles and the phone steps land on the same stops
    root.querySelectorAll('.ih, .sm, .ch, .stc').forEach(btn => btn.addEventListener('click', () => jumpTo(+btn.dataset.go)));
    steps.forEach((st, n) => { st.setAttribute('aria-label', ITEM_NAMES[n]); st.addEventListener('click', () => jumpTo(ITEM_STOP[n])); });
    let nxAt = -1;
    function navUpdate(q){
      const k = nextIndex();
      if (k !== nxAt){
        nxAt = k;
        nx.setAttribute('aria-label', `Next: ${k < STOPS.length ? STOPS[k][1] : 'Continue'}`);
        nx.classList.toggle('first', k === 0); skip.classList.toggle('off', k >= STOPS.length);
      }
      pv.disabled = prevIndex() === -2;
      nxRing.style.strokeDashoffset = 1 - q;
      const r = track.getBoundingClientRect(); document.body.classList.toggle('kp-arc-pinned', r.top <= 1 && r.bottom >= innerHeight - 1);
    }

    // live clips: play only what is on screen (one at a time on phone)
    const vids = [...root.querySelectorAll('.vids video')];
    const io = new IntersectionObserver(es => es.forEach(e => {
      const v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= (innerWidth < 760 ? .7 : .4)){
        if (innerWidth < 760) vids.forEach(o => { if (o !== v) o.pause(); });
        if (!RM) v.play().catch(() => {});
      } else v.pause();
    }), { threshold:[0, .4, .7, 1] });
    vids.forEach(v => io.observe(v));
  
    layout();
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(layout);
    addEventListener('resize', layout);
    new ResizeObserver(layout).observe(art);
    let onScreen = false, running = false;
    new IntersectionObserver(([e]) => {
      onScreen = e.isIntersecting;
      if (onScreen && !running){ running = true; requestAnimationFrame(frame); }
    }, { rootMargin:'100% 0px' }).observe(track);
  
  }

  if (!customElements.get('kp-arc-story')) {
    customElements.define('kp-arc-story', class extends HTMLElement {
      connectedCallback(){
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        init(this);
      }
    });
  }
})();
